import React, { useEffect, useState } from "react";
import { roundOffCostWithNoFraction } from "../../../../Components/Functions/amt.fun";
import { getQuotationFor } from "../../../../Components/Functions/word.fun";

function roundUp(cost) {
  cost = Math.ceil(cost);
  return cost;
}
const getRevenue = (price, plant, allQData) => {
  let harvest = 0;

  switch (plant?.grow_system) {
    case "nftA":
      harvest =
        plant.productionPerPlantMonth *
        allQData?.number_of_plants?.numberOfPlantsInA_Frame;
      break;

    case "fb":
      harvest =
        plant.productionPerPlantMonth *
        allQData?.number_of_plants?.numberOfPlantsInFlatBed;
      break;

    case "gb":
      harvest =
        plant.productionPerPlantMonth *
        allQData?.number_of_plants?.numberOfPlantsInGrowBag;
      break;

    case "db":
      harvest =
        plant.productionPerPlantMonth *
        allQData?.number_of_plants?.numberOfPlantsInDutchBucket;
      break;

    default:
      harvest = 0;
  }

  // Round once and use everywhere
  harvest = roundUp(harvest);

  return price * harvest;
};

const getTotalCost = (italianBasilArray, bellPaperArray, allQData) => {
  let tCost = 0;
  if (italianBasilArray?.length > 0) {
    italianBasilArray.map((plant) => {
      tCost += getRevenue(
        (plant?.min_price + plant?.max_price) / 2,
        plant,
        allQData
      );
    });
  }
  if (bellPaperArray?.length > 0) {
    bellPaperArray.map((plant) => {
      tCost += getRevenue(
        (plant?.min_price + plant?.max_price) / 2,
        plant,
        allQData
      );
    });
  }

  return tCost;
};

function calculatePMT(principal, annualRate, years) {
  // Convert annual rate from percentage to decimal
  const rate = annualRate / 100;

  // Total number of annual payments
  const totalPayments = years;

  // If the interest rate is 0, payments are simply principal divided by total payments
  if (rate === 0) {
    return principal / totalPayments;
  }

  // PMT formula for annual payments
  const numerator = principal * rate * Math.pow(1 + rate, totalPayments);
  const denominator = Math.pow(1 + rate, totalPayments) - 1;

  // Calculate PMT
  const pmt = numerator / denominator;

  return pmt;
}
// function calculatePMT(principal, annualRate, years) {
//   // Convert annual rate to yearly rate (unchanged)
//   const yearlyRate = annualRate / 100;

//   // Total number of yearly payments
//   const totalPayments = years;

//   // If the interest rate is 0, payments are simply principal divided by total payments
//   if (yearlyRate === 0) {
//     return principal / totalPayments;
//   }

//   // PMT formula for annual payment
//   let num = principal * yearlyRate * Math.pow(1 + yearlyRate, totalPayments);
//   let deno = Math.pow(1 + yearlyRate, totalPayments) - 1;
//   const pmt = num / deno;

//   return pmt;
// }

const getHeading = (italianBasilArray, bellPaperArray) => {
  if (
    italianBasilArray &&
    bellPaperArray &&
    italianBasilArray.length > 0 &&
    bellPaperArray.length > 0
  ) {
    return `Case study: ${italianBasilArray?.[0]?.plantName} + ${bellPaperArray?.[0]?.plantName}`;
  } else if (italianBasilArray && italianBasilArray.length > 0) {
    return `Case study: ${italianBasilArray?.[0]?.plantName}`;
  } else if (bellPaperArray && bellPaperArray.length > 0) {
    return `Case study: ${bellPaperArray?.[0]?.plantName}`;
  } else {
    return "Case study: N/A";
  }
};

const BorrowFromBankSchedule2 = ({ data, allQData }) => {
  const [italianBasilArray, setItalianBasilArray] = useState([]);
  const [bellPaperArray, setBellPaperArray] = useState([]);
  const [totalCost, setTotalCost] = useState(0);
  const [qCost, setQuotationCost] = useState(0);
  const [totalPer, setTotalPerctage] = useState(0);

  useEffect(() => {
    let totalPerctage = 0.9;
    if (allQData?.area_in?.area_in_sqmeter) {
      let area = allQData?.area_in?.area_in_sqmeter;
      if (area > 2000 && area <= 4000) {
        totalPerctage = 0.85;
      } else if (area > 4000 && area <= 6000) {
        totalPerctage = 0.8;
      } else if (area > 6000) {
        totalPerctage = 0.75;
      }
    }
    let total = 0;
    if (allQData?.quotationNumber?.includes("A/V2")) {
      total = +allQData?.quotationMatrixCost?.asPerIndustryCost;
    } else {
      total =
        +allQData?.input_info?.overrideUnitCost ||
        +allQData?.quotationMatrixCost?.total_cost;
    }
    if (
      allQData?.input_info?.addOnParticulars &&
      allQData?.input_info?.addOnParticularsPrice
    ) {
      total += +allQData?.input_info?.addOnParticularsPrice;
    }
    setTotalPerctage(totalPerctage);
    setQuotationCost(total);
  }, [allQData]);
  useEffect(() => {
    let area = allQData?.area_in?.area_in_sqmeter;
    let ftDataItalianBasil = allQData?.plant_grow?.updatedPlantsList?.filter(
      (item) => {
        return area < 2000
          ? item?.plantName === "Italian Basil"
          : item?.plantName === "Super Spinach";
      }
    );
    let ftDataBellPapper = allQData?.plant_grow?.updatedPlantsList?.filter(
      (item) => {
        return area < 2000
          ? item?.plantName === "Bell Papper"
          : item?.plantName === "Cucumber English";
      }
    );
    setBellPaperArray(ftDataBellPapper);
    setItalianBasilArray(ftDataItalianBasil);
  }, [allQData]);
  useEffect(() => {
    if (allQData && italianBasilArray && bellPaperArray) {
      setTotalCost(getTotalCost(italianBasilArray, bellPaperArray, allQData));
    }
  }, [allQData, italianBasilArray, bellPaperArray]);

  // table 1

  let amount = qCost;

  if (data?.fundingAmmountType == "postGST") {
    amount = amount + amount * 0.18;
  }

  const projectCostC2 = amount;
  const totalProjectCostC3 = amount;
  let borrowFromBankPercentC7 = data?.borrowFromBank;
  let ownContributionPercentageC6 = 100 - borrowFromBankPercentC7;
  const ownContributionAmountD6 =
    totalProjectCostC3 - (totalProjectCostC3 * borrowFromBankPercentC7) / 100;
  const borrowFromBankAmountD7 = totalProjectCostC3 - ownContributionAmountD6;
  let rateOfIntC8 = +data?.rateOfInt || 9;
  let durationOfYearsC9 = +data?.tenure || 7;
  // let table 2
  let serial = 1;
  let printingStationary = 0;
  let opBal = 0;
  let capacityUnilization = 0;
  let salesReceipts1 = (capacityUnilization = totalCost * totalPer * 12);
  let salesReceipts2 = (capacityUnilization = capacityUnilization * 1.085);
  let salesReceipts3 = (capacityUnilization = capacityUnilization * 1.085);
  let salesReceipts4 = (capacityUnilization = capacityUnilization * 1.085);
  let salesReceipts5 = (capacityUnilization = capacityUnilization * 1.085);
  let salesReceipts6 = (capacityUnilization = capacityUnilization * 1.085);
  let salesReceipts7 = (capacityUnilization = capacityUnilization * 1.085);

  let salesC2 = (capacityUnilization = totalCost * totalPer * 12);
  let salesD2 = (capacityUnilization = capacityUnilization * 1.085);
  let salesE2 = (capacityUnilization = capacityUnilization * 1.085);
  let salesF2 = (capacityUnilization = capacityUnilization * 1.085);
  let salesG2 = (capacityUnilization = capacityUnilization * 1.085);
  let salesH2 = (capacityUnilization = capacityUnilization * 1.085);
  let salesI2 = (capacityUnilization = capacityUnilization * 1.085);

  // let salesC2 = (capacityUnilization = (totalProjectCostC3 * 64) / 100);
  // let salesD2 = (capacityUnilization = capacityUnilization * 1.05);
  // let salesE2 = (capacityUnilization = capacityUnilization * 1.05);
  // let salesF2 = (capacityUnilization = capacityUnilization * 1.05);
  // let salesG2 = (capacityUnilization = capacityUnilization * 1.05);
  // let salesH2 = (capacityUnilization = capacityUnilization * 1.05);
  // let salesI2 = (capacityUnilization = capacityUnilization * 1.05);

  let closingStock1stYear = (salesC2 * 6.54160342026) / 100; //have to count
  let closingStockC3 = closingStock1stYear;
  let closingStockD3 = (closingStock1stYear = closingStock1stYear * 1.05);
  let closingStockE3 = (closingStock1stYear = closingStock1stYear * 1.05);
  let closingStockF3 = (closingStock1stYear = closingStock1stYear * 1.05);
  let closingStockG3 = (closingStock1stYear = closingStock1stYear * 1.05);
  let closingStockH3 = (closingStock1stYear = closingStock1stYear * 1.05);
  let closingStockI3 = (closingStock1stYear = closingStock1stYear * 1.05);

  let salesAndClosingTotalC4 = salesC2 + closingStockC3;
  let salesAndClosingTotalD4 = salesD2 + closingStockD3;
  let salesAndClosingTotalE4 = salesE2 + closingStockE3;
  let salesAndClosingTotalF4 = salesF2 + closingStockF3;
  let salesAndClosingTotalG4 = salesG2 + closingStockG3;
  let salesAndClosingTotalH4 = salesH2 + closingStockH3;
  let salesAndClosingTotalI4 = salesI2 + closingStockI3;

  let opningStock1stYear = 0;
  let DEOpenStockC6 = opningStock1stYear;
  let DEOpenStockD6 = closingStockC3;
  let DEOpenStockE6 = closingStockD3;
  let DEOpenStockF6 = closingStockE3;
  let DEOpenStockG6 = closingStockF3;
  let DEOpenStockH6 = closingStockG3;
  let DEOpenStockI6 = closingStockH3;

  let DEPurchaseAndMaterialC7 = salesC2 * 0.155;
  let DEPurchaseAndMaterialD7 = salesD2 * 0.155 - DEOpenStockD6;
  let DEPurchaseAndMaterialE7 = salesE2 * 0.155 - DEOpenStockE6;
  let DEPurchaseAndMaterialF7 = salesF2 * 0.155 - DEOpenStockF6;
  let DEPurchaseAndMaterialG7 = salesG2 * 0.155 - DEOpenStockG6;
  let DEPurchaseAndMaterialH7 = salesH2 * 0.155 - DEOpenStockH6;
  let DEPurchaseAndMaterialI7 = salesI2 * 0.155 - DEOpenStockI6;

  let DEWagesAndLobourC8 = salesC2 * 0.092;
  let DEWagesAndLobourD8 = salesD2 * 0.092;
  let DEWagesAndLobourE8 = salesE2 * 0.092;
  let DEWagesAndLobourF8 = salesF2 * 0.092;
  let DEWagesAndLobourG8 = salesG2 * 0.092;
  let DEWagesAndLobourH8 = salesH2 * 0.092;
  let DEWagesAndLobourI8 = salesI2 * 0.092;

  let DEPowerAndFuelC9 = salesC2 * 0.078;
  let DEPowerAndFuelD9 = salesD2 * 0.078;
  let DEPowerAndFuelE9 = salesE2 * 0.078;
  let DEPowerAndFuelF9 = salesF2 * 0.078;
  let DEPowerAndFuelG9 = salesG2 * 0.078;
  let DEPowerAndFuelH9 = salesH2 * 0.078;
  let DEPowerAndFuelI9 = salesI2 * 0.078;

  let DEFreightAndTransC10 = salesC2 * 0.07;
  let DEFreightAndTransD10 = salesD2 * 0.07;
  let DEFreightAndTransE10 = salesE2 * 0.07;
  let DEFreightAndTransF10 = salesF2 * 0.07;
  let DEFreightAndTransG10 = salesG2 * 0.07;
  let DEFreightAndTransH10 = salesH2 * 0.07;
  let DEFreightAndTransI10 = salesI2 * 0.07;

  let DETotalC11 =
    DEOpenStockC6 +
    DEPurchaseAndMaterialC7 +
    DEWagesAndLobourC8 +
    DEPowerAndFuelC9 +
    DEFreightAndTransC10;
  let DETotalD11 =
    DEOpenStockD6 +
    DEPurchaseAndMaterialD7 +
    DEWagesAndLobourD8 +
    DEPowerAndFuelD9 +
    DEFreightAndTransD10;
  let DETotalE11 =
    DEOpenStockE6 +
    DEPurchaseAndMaterialE7 +
    DEWagesAndLobourE8 +
    DEPowerAndFuelE9 +
    DEFreightAndTransE10;
  let DETotalF11 =
    DEOpenStockF6 +
    DEPurchaseAndMaterialF7 +
    DEWagesAndLobourF8 +
    DEPowerAndFuelF9 +
    DEFreightAndTransF10;
  let DETotalG11 =
    DEOpenStockG6 +
    DEPurchaseAndMaterialG7 +
    DEWagesAndLobourG8 +
    DEPowerAndFuelG9 +
    DEFreightAndTransG10;
  let DETotalH11 =
    DEOpenStockH6 +
    DEPurchaseAndMaterialH7 +
    DEWagesAndLobourH8 +
    DEPowerAndFuelH9 +
    DEFreightAndTransH10;
  let DETotalI11 =
    DEOpenStockI6 +
    DEPurchaseAndMaterialI7 +
    DEWagesAndLobourI8 +
    DEPowerAndFuelI9 +
    DEFreightAndTransI10;

  let grossProfitC12 = salesAndClosingTotalC4 - DETotalC11;
  let grossProfitD12 = salesAndClosingTotalD4 - DETotalD11;
  let grossProfitE12 = salesAndClosingTotalE4 - DETotalE11;
  let grossProfitF12 = salesAndClosingTotalF4 - DETotalF11;
  let grossProfitG12 = salesAndClosingTotalG4 - DETotalG11;
  let grossProfitH12 = salesAndClosingTotalH4 - DETotalH11;
  let grossProfitI12 = salesAndClosingTotalI4 - DETotalI11;

  // indirect expence
  let printAndStationaryC14 = (printingStationary =
    allQData?.opex_cost?.opex_labour_cost * 12 * 0.02);
  let printAndStationaryD14 = (printingStationary = printingStationary * 1.2);
  let printAndStationaryE14 = (printingStationary = printingStationary * 1.2);
  let printAndStationaryF14 = (printingStationary = printingStationary * 1.4);
  let printAndStationaryG14 = (printingStationary = printingStationary * 1.4);
  let printAndStationaryH14 = (printingStationary = printingStationary * 1.4);
  let printAndStationaryI14 = (printingStationary = printingStationary * 1.4);

  let postageAndTelephoneC15 = (printingStationary =
    allQData?.opex_cost?.opex_labour_cost * 12 * 0.04);
  let postageAndTelephoneD15 = (printingStationary = printingStationary * 1.3);
  let postageAndTelephoneE15 = (printingStationary = printingStationary * 1.3);
  let postageAndTelephoneF15 = (printingStationary = printingStationary * 1.4);
  let postageAndTelephoneG15 = (printingStationary = printingStationary * 1.4);
  let postageAndTelephoneH15 = (printingStationary = printingStationary * 1.4);
  let postageAndTelephoneI15 = (printingStationary = printingStationary * 1.4);

  let travellingAndConveyanceExpsC16 = (printingStationary =
    allQData?.opex_cost?.opex_labour_cost * 12 * 0.09);
  let travellingAndConveyanceExpsD16 = (printingStationary =
    printingStationary * 1.3);
  let travellingAndConveyanceExpsE16 = (printingStationary =
    printingStationary * 1.3);
  let travellingAndConveyanceExpsF16 = (printingStationary =
    printingStationary * 1.5);
  let travellingAndConveyanceExpsG16 = (printingStationary =
    printingStationary * 1.5);
  let travellingAndConveyanceExpsH16 = (printingStationary =
    printingStationary * 1.5);
  let travellingAndConveyanceExpsI16 = (printingStationary =
    printingStationary * 1.5);

  let repairsAndMaintainanceC17 = (printingStationary =
    allQData?.opex_cost?.opex_labour_cost * 12 * 0.36);
  let repairsAndMaintainanceD17 = (printingStationary =
    printingStationary * 1.1);
  let repairsAndMaintainanceE17 = (printingStationary =
    printingStationary * 1.1);
  let repairsAndMaintainanceF17 = (printingStationary =
    printingStationary * 1.1);
  let repairsAndMaintainanceG17 = (printingStationary =
    printingStationary * 1.1);
  let repairsAndMaintainanceH17 = (printingStationary =
    printingStationary * 1.1);
  let repairsAndMaintainanceI17 = (printingStationary =
    printingStationary * 1.1);

  let professionalFeesC18 = (printingStationary =
    allQData?.opex_cost?.opex_labour_cost * 12 * 0.13);
  let professionalFeesD18 = (printingStationary = printingStationary * 1.1);
  let professionalFeesE18 = (printingStationary = printingStationary * 1.1);
  let professionalFeesF18 = (printingStationary = printingStationary * 1.1);
  let professionalFeesG18 = (printingStationary = printingStationary * 1.1);
  let professionalFeesH18 = (printingStationary = printingStationary * 1.1);
  let professionalFeesI18 = (printingStationary = printingStationary * 1.1);

  let advertisementC19 = (printingStationary =
    allQData?.opex_cost?.opex_labour_cost * 12 * 0.13);
  let advertisementD19 = (printingStationary = printingStationary * 1.1);
  let advertisementE19 = (printingStationary = printingStationary * 1.1);
  let advertisementF19 = (printingStationary = printingStationary * 1.2);
  let advertisementG19 = (printingStationary = printingStationary * 1.2);
  let advertisementH19 = (printingStationary = printingStationary * 1.2);
  let advertisementI19 = (printingStationary = printingStationary * 1.2);

  let auditFeesC20 = (printingStationary =
    allQData?.opex_cost?.opex_labour_cost * 12 * 0.05);
  let auditFeesD20 = (printingStationary = printingStationary * 1.2);
  let auditFeesE20 = (printingStationary = printingStationary * 1.2);
  let auditFeesF20 = (printingStationary = printingStationary * 1.2);
  let auditFeesG20 = (printingStationary = printingStationary * 1.2);
  let auditFeesH20 = (printingStationary = printingStationary * 1.2);
  let auditFeesI20 = (printingStationary = printingStationary * 1.2);

  let insuranceChargesC21 = (printingStationary =
    allQData?.opex_cost?.opex_labour_cost * 12 * 0.09);
  let insuranceChargesD21 = insuranceChargesC21;
  let insuranceChargesE21 = insuranceChargesC21;
  let insuranceChargesF21 = insuranceChargesC21;
  let insuranceChargesG21 = insuranceChargesC21;
  let insuranceChargesH21 = insuranceChargesC21;
  let insuranceChargesI21 = insuranceChargesC21;

  let officeExpensesC22 = (printingStationary =
    allQData?.opex_cost?.opex_labour_cost * 12 * 0.09);
  let officeExpensesD22 = (printingStationary = printingStationary * 1.3);
  let officeExpensesE22 = (printingStationary = printingStationary * 1.3);
  let officeExpensesF22 = (printingStationary = printingStationary * 1.3);
  let officeExpensesG22 = (printingStationary = printingStationary * 1.3);
  let officeExpensesH22 = (printingStationary = printingStationary * 1.3);
  let officeExpensesI22 = (printingStationary = printingStationary * 1.3);

  let IETotalC23 =
    printAndStationaryC14 +
    postageAndTelephoneC15 +
    travellingAndConveyanceExpsC16 +
    repairsAndMaintainanceC17 +
    professionalFeesC18 +
    advertisementC19 +
    auditFeesC20 +
    insuranceChargesC21 +
    officeExpensesC22;
  let IETotalD23 =
    printAndStationaryD14 +
    postageAndTelephoneD15 +
    travellingAndConveyanceExpsD16 +
    repairsAndMaintainanceD17 +
    professionalFeesD18 +
    advertisementD19 +
    auditFeesD20 +
    insuranceChargesD21 +
    officeExpensesD22;
  let IETotalE23 =
    printAndStationaryE14 +
    postageAndTelephoneE15 +
    travellingAndConveyanceExpsE16 +
    repairsAndMaintainanceE17 +
    professionalFeesE18 +
    advertisementE19 +
    auditFeesE20 +
    insuranceChargesE21 +
    officeExpensesE22;
  let IETotalF23 =
    printAndStationaryF14 +
    postageAndTelephoneF15 +
    travellingAndConveyanceExpsF16 +
    repairsAndMaintainanceF17 +
    professionalFeesF18 +
    advertisementF19 +
    auditFeesF20 +
    insuranceChargesF21 +
    officeExpensesF22;
  let IETotalG23 =
    printAndStationaryG14 +
    postageAndTelephoneG15 +
    travellingAndConveyanceExpsG16 +
    repairsAndMaintainanceG17 +
    professionalFeesG18 +
    advertisementG19 +
    auditFeesG20 +
    insuranceChargesG21 +
    officeExpensesG22;
  let IETotalH23 =
    printAndStationaryH14 +
    postageAndTelephoneH15 +
    travellingAndConveyanceExpsH16 +
    repairsAndMaintainanceH17 +
    professionalFeesH18 +
    advertisementH19 +
    auditFeesH20 +
    insuranceChargesH21 +
    officeExpensesH22;
  let IETotalI23 =
    printAndStationaryI14 +
    postageAndTelephoneI15 +
    travellingAndConveyanceExpsI16 +
    repairsAndMaintainanceI17 +
    professionalFeesI18 +
    advertisementI19 +
    auditFeesI20 +
    insuranceChargesI21 +
    officeExpensesI22;

  let profitBeforeInterestC24 = grossProfitC12 - IETotalC23;
  let profitBeforeInterestD24 = grossProfitD12 - IETotalD23;
  let profitBeforeInterestE24 = grossProfitE12 - IETotalE23;
  let profitBeforeInterestF24 = grossProfitF12 - IETotalF23;
  let profitBeforeInterestG24 = grossProfitG12 - IETotalG23;
  let profitBeforeInterestH24 = grossProfitH12 - IETotalH23;
  let profitBeforeInterestI24 = grossProfitI12 - IETotalI23;

  // let table 5

  let opBalC3 = (opBal = totalProjectCostC3);
  let dpC4 = opBalC3 * 0.1;

  let opBalD3 = opBalC3 - dpC4;
  let dpD4 = opBalD3 * 0.1;

  let opBalE3 = opBalD3 - dpD4;
  let dpE4 = opBalE3 * 0.1;

  let opBalF3 = opBalE3 - dpE4;
  let dpF4 = opBalF3 * 0.1;

  let opBalG3 = opBalF3 - dpF4;
  let dpG4 = opBalG3 * 0.1;

  let opBalH3 = opBalG3 - dpG4;
  let dpH4 = opBalH3 * 0.1;

  let opBalI3 = opBalH3 - dpH4;
  let dpI4 = opBalI3 * 0.1;

  let opBalJ3 = opBalI3 - dpI4;

  let closingBalC5 = opBalC3 - dpC4;
  let closingBalD5 = opBalD3 - dpD4;
  let closingBalE5 = opBalE3 - dpE4;
  let closingBalF5 = opBalF3 - dpF4;
  let closingBalG5 = opBalG3 - dpG4;
  let closingBalH5 = opBalH3 - dpH4;
  let closingBalI5 = opBalI3 - dpI4;

  let grossOpeningC7 = opBalC3;
  let grossOpeningD7 = opBalD3;
  let grossOpeningE7 = opBalE3;
  let grossOpeningF7 = opBalF3;
  let grossOpeningG7 = opBalG3;
  let grossOpeningH7 = opBalH3;
  let grossOpeningI7 = opBalI3;

  let grossTotalDepC8 = dpC4;
  let grossTotalDepD8 = dpD4;
  let grossTotalDepE8 = dpE4;
  let grossTotalDepF8 = dpF4;
  let grossTotalDepG8 = dpG4;
  let grossTotalDepH8 = dpH4;
  let grossTotalDepI8 = dpI4;

  let grossClosingC9 = closingBalC5;
  let grossClosingD9 = closingBalD5;
  let grossClosingE9 = closingBalE5;
  let grossClosingF9 = closingBalF5;
  let grossClosingG9 = closingBalG5;
  let grossClosingH9 = closingBalH5;
  let grossClosingI9 = closingBalI5;

  // table 6
  //   let totalInstallMents = calculatePMT(borrowFromBankAmountD7, 9, 7) * 12;
  let totalInstallMents = calculatePMT(
    borrowFromBankAmountD7,
    rateOfIntC8,
    durationOfYearsC9
  );
  let remBal;

  let OutstandingBalanceD2 = borrowFromBankAmountD7;
  let termLoanAmmout = borrowFromBankAmountD7;
  let InterestPaymentE2 = (OutstandingBalanceD2 * rateOfIntC8) / 100;
  let PrincipalPaymentF2 = totalInstallMents - InterestPaymentE2;
  let TotalInstallmentG2 = totalInstallMents;
  let RemainingBalanceH2 = (remBal = OutstandingBalanceD2 - PrincipalPaymentF2);

  let OutstandingBalanceD3 = remBal;
  let InterestPaymentE3 = (OutstandingBalanceD3 * rateOfIntC8) / 100;
  let PrincipalPaymentF3 = totalInstallMents - InterestPaymentE3;
  let TotalInstallmentG3 = totalInstallMents;
  let RemainingBalanceH3 = (remBal = OutstandingBalanceD3 - PrincipalPaymentF3);

  let OutstandingBalanceD4 = remBal;
  let InterestPaymentE4 = (OutstandingBalanceD4 * rateOfIntC8) / 100;
  let PrincipalPaymentF4 = totalInstallMents - InterestPaymentE4;
  let TotalInstallmentG4 = totalInstallMents;
  let RemainingBalanceH4 = (remBal = OutstandingBalanceD4 - PrincipalPaymentF4);

  let OutstandingBalanceD5 = remBal;
  let InterestPaymentE5 = (OutstandingBalanceD5 * rateOfIntC8) / 100;
  let PrincipalPaymentF5 = totalInstallMents - InterestPaymentE5;
  let TotalInstallmentG5 = totalInstallMents;
  let RemainingBalanceH5 = (remBal = OutstandingBalanceD5 - PrincipalPaymentF5);

  let OutstandingBalanceD6 = remBal;
  let InterestPaymentE6 = (OutstandingBalanceD6 * rateOfIntC8) / 100;
  let PrincipalPaymentF6 = totalInstallMents - InterestPaymentE6;
  let TotalInstallmentG6 = totalInstallMents;
  let RemainingBalanceH6 = (remBal = OutstandingBalanceD6 - PrincipalPaymentF6);

  let OutstandingBalanceD7 = remBal;
  let InterestPaymentE7 = (OutstandingBalanceD7 * rateOfIntC8) / 100;
  let PrincipalPaymentF7 = totalInstallMents - InterestPaymentE7;
  let TotalInstallmentG7 = totalInstallMents;
  let RemainingBalanceH7 = (remBal = OutstandingBalanceD7 - PrincipalPaymentF7);

  let OutstandingBalanceD8 = remBal;
  let InterestPaymentE8 = (OutstandingBalanceD8 * rateOfIntC8) / 100;
  let PrincipalPaymentF8 = totalInstallMents - InterestPaymentE8;
  let TotalInstallmentG8 = totalInstallMents;
  let RemainingBalanceH8 = (remBal = OutstandingBalanceD8 - PrincipalPaymentF8);

  // table 2

  let lessDepC25 = dpC4;
  let lessDepD25 = dpD4;
  let lessDepE25 = dpE4;
  let lessDepF25 = dpF4;
  let lessDepG25 = dpG4;
  let lessDepH25 = dpH4;
  let lessDepI25 = dpI4;

  let profBefoIntAndTaxC26 = profitBeforeInterestC24 - lessDepC25;
  let profBefoIntAndTaxD26 = profitBeforeInterestD24 - lessDepD25;
  let profBefoIntAndTaxE26 = profitBeforeInterestE24 - lessDepE25;
  let profBefoIntAndTaxF26 = profitBeforeInterestF24 - lessDepF25;
  let profBefoIntAndTaxG26 = profitBeforeInterestG24 - lessDepG25;
  let profBefoIntAndTaxH26 = profitBeforeInterestH24 - lessDepH25;
  let profBefoIntAndTaxI26 = profitBeforeInterestI24 - lessDepI25;

  let profBefoIntAndTaxC27 = InterestPaymentE2;
  let profBefoIntAndTaxD27 = InterestPaymentE3;
  let profBefoIntAndTaxE27 = InterestPaymentE4;
  let profBefoIntAndTaxF27 = InterestPaymentE5;
  let profBefoIntAndTaxG27 = InterestPaymentE6;
  let profBefoIntAndTaxH27 = InterestPaymentE7;
  let profBefoIntAndTaxI27 = InterestPaymentE8;

  let profBefoTaxC28 = profBefoIntAndTaxC26 - profBefoIntAndTaxC27;
  let profBefoTaxD28 = profBefoIntAndTaxD26 - profBefoIntAndTaxD27;
  let profBefoTaxE28 = profBefoIntAndTaxE26 - profBefoIntAndTaxE27;
  let profBefoTaxF28 = profBefoIntAndTaxF26 - profBefoIntAndTaxF27;
  let profBefoTaxG28 = profBefoIntAndTaxG26 - profBefoIntAndTaxG27;
  let profBefoTaxH28 = profBefoIntAndTaxH26 - profBefoIntAndTaxH27;
  let profBefoTaxI28 = profBefoIntAndTaxI26 - profBefoIntAndTaxI27;

  // let lessTax30PerC29 = profBefoTaxC28 * 0.25;
  // let lessTax30PerD29 = profBefoTaxD28 * 0.25;
  // let lessTax30PerE29 = profBefoTaxE28 * 0.25;
  // let lessTax30PerF29 = profBefoTaxF28 * 0.25;
  // let lessTax30PerG29 = profBefoTaxG28 * 0.25;
  // let lessTax30PerH29 = profBefoTaxH28 * 0.25;
  // let lessTax30PerI29 = profBefoTaxI28 * 0.25;

  let lessTax30PerC29 = profBefoTaxC28 * 0;
  let lessTax30PerD29 = profBefoTaxD28 * 0;
  let lessTax30PerE29 = profBefoTaxE28 * 0;
  let lessTax30PerF29 = profBefoTaxF28 * 0;
  let lessTax30PerG29 = profBefoTaxG28 * 0;
  let lessTax30PerH29 = profBefoTaxH28 * 0;
  let lessTax30PerI29 = profBefoTaxI28 * 0;

  let lessTax30PerC30 = profBefoTaxC28 - lessTax30PerC29;
  let lessTax30PerD30 = profBefoTaxD28 - lessTax30PerD29;
  let lessTax30PerE30 = profBefoTaxE28 - lessTax30PerE29;
  let lessTax30PerF30 = profBefoTaxF28 - lessTax30PerF29;
  let lessTax30PerG30 = profBefoTaxG28 - lessTax30PerG29;
  let lessTax30PerH30 = profBefoTaxH28 - lessTax30PerH29;
  let lessTax30PerI30 = profBefoTaxI28 - lessTax30PerI29;

  let noNameC31 = (lessTax30PerC30 / salesAndClosingTotalC4) * 100;
  let noNameD31 = (lessTax30PerD30 / salesAndClosingTotalD4) * 100;
  let noNameE31 = (lessTax30PerE30 / salesAndClosingTotalE4) * 100;
  let noNameF31 = (lessTax30PerF30 / salesAndClosingTotalF4) * 100;
  let noNameG31 = (lessTax30PerG30 / salesAndClosingTotalG4) * 100;
  let noNameH31 = (lessTax30PerH30 / salesAndClosingTotalH4) * 100;
  let noNameI31 = (lessTax30PerI30 / salesAndClosingTotalI4) * 100;

  //  table CF

  let netProfBefTaxD5 = profBefoTaxC28;
  let netProfBefTaxE5 = profBefoTaxD28;
  let netProfBefTaxF5 = profBefoTaxE28;
  let netProfBefTaxG5 = profBefoTaxF28;
  let netProfBefTaxH5 = profBefoTaxG28;
  let netProfBefTaxI5 = profBefoTaxH28;
  let netProfBefTaxJ5 = profBefoTaxI28;

  let depCFD7 = lessDepC25;
  let depCFE7 = lessDepD25;
  let depCFF7 = lessDepE25;
  let depCFG7 = lessDepF25;
  let depCFH7 = lessDepG25;
  let depCFI7 = lessDepH25;
  let depCFJ7 = lessDepI25;

  let IFCD8 = profBefoIntAndTaxC27;
  let IFCE8 = profBefoIntAndTaxD27;
  let IFCF8 = profBefoIntAndTaxE27;
  let IFCG8 = profBefoIntAndTaxF27;
  let IFCH8 = profBefoIntAndTaxG27;
  let IFCI8 = profBefoIntAndTaxH27;
  let IFCJ8 = profBefoIntAndTaxI27;

  let operatinProfitD9 = netProfBefTaxD5 + depCFD7 + IFCD8;
  let operatinProfitE9 = netProfBefTaxE5 + depCFE7 + IFCE8;
  let operatinProfitF9 = netProfBefTaxF5 + depCFF7 + IFCF8;
  let operatinProfitG9 = netProfBefTaxG5 + depCFG7 + IFCG8;
  let operatinProfitH9 = netProfBefTaxH5 + depCFH7 + IFCH8;
  let operatinProfitI9 = netProfBefTaxI5 + depCFI7 + IFCI8;
  let operatinProfitJ9 = netProfBefTaxJ5 + depCFJ7 + IFCJ8;

  let sundryDebtorsC7 = salesC2 * 0.091;
  let sundryDebtorsD7 = salesD2 * 0.12;
  let sundryDebtorsE7 = salesE2 * 0.13;
  let sundryDebtorsF7 = salesF2 * 0.16;
  let sundryDebtorsG7 = salesG2 * 0.17;
  let sundryDebtorsH7 = salesH2 * 0.175;
  let sundryDebtorsI7 = salesI2 * 0.178;

  let decInReciveblesD11 = 0 - sundryDebtorsC7;
  let decInReciveblesE11 = sundryDebtorsC7 - sundryDebtorsD7;
  let decInReciveblesF11 = sundryDebtorsD7 - sundryDebtorsE7;
  let decInReciveblesG11 = sundryDebtorsE7 - sundryDebtorsF7;
  let decInReciveblesH11 = sundryDebtorsF7 - sundryDebtorsG7;
  let decInReciveblesI11 = sundryDebtorsG7 - sundryDebtorsH7;
  let decInReciveblesJ11 = sundryDebtorsH7 - sundryDebtorsI7;

  let stockInTradeC8 = DEOpenStockD6;
  let stockInTradeD8 = DEOpenStockE6;
  let stockInTradeE8 = DEOpenStockF6;
  let stockInTradeF8 = DEOpenStockG6;
  let stockInTradeG8 = DEOpenStockH6;
  let stockInTradeH8 = DEOpenStockI6;
  let stockInTradeI8 = stockInTradeH8 * 1.1;

  let decInInventoriesD12 = 0 - stockInTradeC8;
  let decInInventoriesE12 = stockInTradeC8 - stockInTradeD8;
  let decInInventoriesF12 = stockInTradeD8 - stockInTradeE8;
  let decInInventoriesG12 = stockInTradeE8 - stockInTradeF8;
  let decInInventoriesH12 = stockInTradeF8 - stockInTradeG8;
  let decInInventoriesI12 = stockInTradeG8 - stockInTradeH8;
  let decInInventoriesJ12 = stockInTradeH8 - stockInTradeI8;

  // table bs

  let additionD5 = totalProjectCostC3;
  let additionE5 = 0;
  let additionF5 = 0;
  let additionG5 = 0;
  let additionH5 = 0;
  let additionI5 = 0;
  let additionJ5 = 0;

  let lessDepD6 = dpC4;
  let lessDepE6 = dpD4;
  let lessDepF6 = dpE4;
  let lessDepG6 = dpF4;
  let lessDepH6 = dpG4;
  let lessDepI6 = dpH4;
  let lessDepJ6 = dpI4;

  let grossBlockD4 = 0;
  let netBlockD7 = grossBlockD4 + additionD5 - lessDepD6;
  let grossBlockE4 = netBlockD7;
  let netBlockE7 = grossBlockE4 + additionE5 - lessDepE6;
  let grossBlockF4 = netBlockE7;
  let netBlockF7 = grossBlockF4 + additionF5 - lessDepF6;
  let grossBlockG4 = netBlockF7;
  let netBlockG7 = grossBlockG4 + additionG5 - lessDepG6;
  let grossBlockH4 = netBlockG7;
  let netBlockH7 = grossBlockH4 + additionH5 - lessDepH6;
  let grossBlockI4 = netBlockH7;
  let netBlockI7 = grossBlockI4 + additionI5 - lessDepI6;
  let grossBlockJ4 = netBlockI7;
  let netBlockJ7 = grossBlockJ4 + additionJ5 - lessDepJ6;

  let investD9 = lessTax30PerC30 * 0;
  let investE9 = (lessTax30PerD30 * 0.22727348) / 100;
  let investF9 = (lessTax30PerE30 * 21.94158937) / 100;
  let investG9 = (lessTax30PerF30 * 46.054052285) / 100;
  let investH9 = (lessTax30PerG30 * 72.30318714) / 100;
  let investI9 = (lessTax30PerH30 * 84.44712143) / 100;
  let investJ9 = (lessTax30PerI30 * 99.931059992) / 100;

  let additionDetailsD22 = ownContributionAmountD6;
  let additionDetailsE22 = 0;
  let additionDetailsF22 = 0;
  let additionDetailsG22 = 0;
  let additionDetailsH22 = 0;
  let additionDetailsI22 = 0;
  let additionDetailsJ22 = 0;

  let netProfD23 = lessTax30PerC30;
  let netProfE23 = lessTax30PerD30;
  let netProfF23 = lessTax30PerE30;
  let netProfG23 = lessTax30PerF30;
  let netProfH23 = lessTax30PerG30;
  let netProfI23 = lessTax30PerH30;
  let netProfJ23 = lessTax30PerI30;

  let lessDrawingsD24 = lessTax30PerC30 * 0.0990248995;
  let lessDrawingsE24 = lessTax30PerD30 * 0.2173521094;
  let lessDrawingsF24 = lessTax30PerE30 * 0.2101821419;
  let lessDrawingsG24 = lessTax30PerF30 * 0.207975166;
  let lessDrawingsH24 = lessTax30PerG30 * 0.2095129454;
  let lessDrawingsI24 = lessTax30PerH30 * 0.2153381892;
  let lessDrawingsJ24 = lessTax30PerI30 * 0.22727348;

  let opBalD21 = 0;

  let capBalD25 = opBalD21 + additionDetailsD22 + netProfD23 - lessDrawingsD24;

  let opBalE21 = capBalD25;

  let capBalE25 = opBalE21 + additionDetailsE22 + netProfE23 - lessDrawingsE24;
  let opBalF21 = capBalE25;

  let capBalF25 = opBalF21 + additionDetailsF22 + netProfF23 - lessDrawingsF24;
  let opBalG21 = capBalF25;

  let capBalG25 = opBalG21 + additionDetailsG22 + netProfG23 - lessDrawingsG24;
  let opBalH21 = capBalG25;

  let capBalH25 = opBalH21 + additionDetailsH22 + netProfH23 - lessDrawingsH24;
  let opBalI21 = capBalH25;

  let capBalI25 = opBalI21 + additionDetailsI22 + netProfI23 - lessDrawingsI24;
  let opBalJ21 = capBalI25;
  let capBalJ25 = opBalJ21 + additionDetailsJ22 + netProfJ23 - lessDrawingsJ24;

  let termLoanFromBankD28 = RemainingBalanceH2;
  let termLoanFromBankE28 = RemainingBalanceH3;
  let termLoanFromBankF28 = RemainingBalanceH4;
  let termLoanFromBankG28 = RemainingBalanceH5;
  let termLoanFromBankH28 = RemainingBalanceH6;
  let termLoanFromBankI28 = RemainingBalanceH7;
  let termLoanFromBankJ28 = RemainingBalanceH8;

  let sundryCreatD31 = salesC2 * 0.045;
  let sundryCreatE31 = salesD2 * 0.045;
  let sundryCreatF31 = salesE2 * 0.045;
  let sundryCreatG31 = salesF2 * 0.045;
  let sundryCreatH31 = salesG2 * 0.045;
  let sundryCreatI31 = salesH2 * 0.045;
  let sundryCreatJ31 = salesI2 * 0.045;

  let currLiabilitiesD30 = sundryCreatD31;
  let currLiabilitiesE30 = sundryCreatE31;
  let currLiabilitiesF30 = sundryCreatF31;
  let currLiabilitiesG30 = sundryCreatG31;
  let currLiabilitiesH30 = sundryCreatH31;
  let currLiabilitiesI30 = sundryCreatI31;
  let currLiabilitiesJ30 = sundryCreatJ31;

  let totalD35 = capBalD25 + termLoanFromBankD28 + currLiabilitiesD30;
  let totalE35 = capBalE25 + termLoanFromBankE28 + currLiabilitiesE30;
  let totalF35 = capBalF25 + termLoanFromBankF28 + currLiabilitiesF30;
  let totalG35 = capBalG25 + termLoanFromBankG28 + currLiabilitiesG30;
  let totalH35 = capBalH25 + termLoanFromBankH28 + currLiabilitiesH30;
  let totalI35 = capBalI25 + termLoanFromBankI28 + currLiabilitiesI30;
  let totalJ35 = capBalJ25 + termLoanFromBankJ28 + currLiabilitiesJ30;

  // table CF

  let incTradeD16 = sundryCreatD31;
  let incTradeE16 = sundryCreatE31 - sundryCreatD31;
  let incTradeF16 = sundryCreatF31 - sundryCreatE31;
  let incTradeG16 = sundryCreatG31 - sundryCreatF31;
  let incTradeH16 = sundryCreatH31 - sundryCreatG31;
  let incTradeI16 = sundryCreatI31 - sundryCreatH31;
  let incTradeJ16 = sundryCreatJ31 - sundryCreatI31;

  let cashGenOpD17 =
    operatinProfitD9 + decInReciveblesD11 + decInInventoriesD12 + incTradeD16;
  let cashGenOpE17 =
    operatinProfitE9 + decInReciveblesE11 + decInInventoriesE12 + incTradeE16;
  let cashGenOpF17 =
    operatinProfitF9 + decInReciveblesF11 + decInInventoriesF12 + incTradeF16;
  let cashGenOpG17 =
    operatinProfitG9 + decInReciveblesG11 + decInInventoriesG12 + incTradeG16;
  let cashGenOpH17 =
    operatinProfitH9 + decInReciveblesH11 + decInInventoriesH12 + incTradeH16;
  let cashGenOpI17 =
    operatinProfitI9 + decInReciveblesI11 + decInInventoriesI12 + incTradeI16;
  let cashGenOpJ17 =
    operatinProfitJ9 + decInReciveblesJ11 + decInInventoriesJ12 + incTradeJ16;

  let incomeTaxPaidD18 = -lessTax30PerC29;
  let incomeTaxPaidE18 = -lessTax30PerD29;
  let incomeTaxPaidF18 = -lessTax30PerE29;
  let incomeTaxPaidG18 = -lessTax30PerF29;
  let incomeTaxPaidH18 = -lessTax30PerG29;
  let incomeTaxPaidI18 = -lessTax30PerH29;
  let incomeTaxPaidJ18 = -lessTax30PerI29;

  let netCashFlowOpD19 = cashGenOpD17 + incomeTaxPaidD18;
  let netCashFlowOpE19 = cashGenOpE17 + incomeTaxPaidE18;
  let netCashFlowOpF19 = cashGenOpF17 + incomeTaxPaidF18;
  let netCashFlowOpG19 = cashGenOpG17 + incomeTaxPaidG18;
  let netCashFlowOpH19 = cashGenOpH17 + incomeTaxPaidH18;
  let netCashFlowOpI19 = cashGenOpI17 + incomeTaxPaidI18;
  let netCashFlowOpJ19 = cashGenOpJ17 + incomeTaxPaidJ18;

  let netCashFlowOpD22 = additionDetailsD22;
  let netCashFlowOpE22 = 0;
  let netCashFlowOpF22 = 0;
  let netCashFlowOpG22 = 0;
  let netCashFlowOpH22 = 0;
  let netCashFlowOpI22 = 0;
  let netCashFlowOpJ22 = 0;

  let purchaseOfAsetsD23 = -additionD5;
  let purchaseOfAsetsE23 = 0;
  let purchaseOfAsetsF23 = 0;
  let purchaseOfAsetsG23 = 0;
  let purchaseOfAsetsH23 = 0;
  let purchaseOfAsetsI23 = 0;
  let purchaseOfAsetsJ23 = 0;

  let invAndNonCurrAsetsD24 = investD9;
  let invAndNonCurrAsetsE24 = investD9 - investE9;
  let invAndNonCurrAsetsF24 = investE9 - investF9;
  let invAndNonCurrAsetsG24 = investF9 - investG9;
  let invAndNonCurrAsetsH24 = investG9 - investH9;
  let invAndNonCurrAsetsI24 = investH9 - investI9;
  let invAndNonCurrAsetsJ24 = investI9 - investJ9;

  let netCashUsedD25 =
    netCashFlowOpD22 + purchaseOfAsetsD23 + invAndNonCurrAsetsD24;
  let netCashUsedE25 =
    netCashFlowOpE22 + purchaseOfAsetsE23 + invAndNonCurrAsetsE24;
  let netCashUsedF25 =
    netCashFlowOpF22 + purchaseOfAsetsF23 + invAndNonCurrAsetsF24;
  let netCashUsedG25 =
    netCashFlowOpG22 + purchaseOfAsetsG23 + invAndNonCurrAsetsG24;
  let netCashUsedH25 =
    netCashFlowOpH22 + purchaseOfAsetsH23 + invAndNonCurrAsetsH24;
  let netCashUsedI25 =
    netCashFlowOpI22 + purchaseOfAsetsI23 + invAndNonCurrAsetsI24;
  let netCashUsedJ25 =
    netCashFlowOpJ22 + purchaseOfAsetsJ23 + invAndNonCurrAsetsJ24;

  let loanDisbursD27 = termLoanFromBankD28;
  let loanDisbursE27 = termLoanFromBankE28 - termLoanFromBankD28;
  let loanDisbursF27 = termLoanFromBankF28 - termLoanFromBankE28;
  let loanDisbursG27 = termLoanFromBankG28 - termLoanFromBankF28;
  let loanDisbursH27 = termLoanFromBankH28 - termLoanFromBankG28;
  let loanDisbursI27 = termLoanFromBankI28 - termLoanFromBankH28;
  let loanDisbursJ27 = termLoanFromBankJ28 - termLoanFromBankI28;

  let itnPaidD28 = -IFCD8;
  let itnPaidE28 = -IFCE8;
  let itnPaidF28 = -IFCF8;
  let itnPaidG28 = -IFCG8;
  let itnPaidH28 = -IFCH8;
  let itnPaidI28 = -IFCI8;
  let itnPaidJ28 = -IFCJ8;

  let drawingsD29 = -lessDrawingsD24;
  let drawingsE29 = -lessDrawingsE24;
  let drawingsF29 = -lessDrawingsF24;
  let drawingsG29 = -lessDrawingsG24;
  let drawingsH29 = -lessDrawingsH24;
  let drawingsI29 = -lessDrawingsI24;
  let drawingsJ29 = -lessDrawingsJ24;

  let netCashUsedD30 = loanDisbursD27 + itnPaidD28 + drawingsD29;
  let netCashUsedE30 = loanDisbursE27 + itnPaidE28 + drawingsE29;
  let netCashUsedF30 = loanDisbursF27 + itnPaidF28 + drawingsF29;
  let netCashUsedG30 = loanDisbursG27 + itnPaidG28 + drawingsG29;
  let netCashUsedH30 = loanDisbursH27 + itnPaidH28 + drawingsH29;
  let netCashUsedI30 = loanDisbursI27 + itnPaidI28 + drawingsI29;
  let netCashUsedJ30 = loanDisbursJ27 + itnPaidJ28 + drawingsJ29;

  let netIncCashD31 = netCashUsedD30 + netCashUsedD25 + netCashFlowOpD19;
  let netIncCashE31 = netCashUsedE30 + netCashUsedE25 + netCashFlowOpE19;
  let netIncCashF31 = netCashUsedF30 + netCashUsedF25 + netCashFlowOpF19;
  let netIncCashG31 = netCashUsedG30 + netCashUsedG25 + netCashFlowOpG19;
  let netIncCashH31 = netCashUsedH30 + netCashUsedH25 + netCashFlowOpH19;
  let netIncCashI31 = netCashUsedI30 + netCashUsedI25 + netCashFlowOpI19;
  let netIncCashJ31 = netCashUsedJ30 + netCashUsedJ25 + netCashFlowOpJ19;

  let cashAndCashEqD32 = 0;
  let netIncCashAtEndD33 =
    netCashUsedD30 + netCashUsedD25 + netCashFlowOpD19 + cashAndCashEqD32;
  let cashAndCashEqE32 = netIncCashAtEndD33;
  let netIncCashAtEndE33 =
    netCashUsedE30 + netCashUsedE25 + netCashFlowOpE19 + cashAndCashEqE32;
  let cashAndCashEqF32 = netIncCashAtEndE33;
  let netIncCashAtEndF33 =
    netCashUsedF30 + netCashUsedF25 + netCashFlowOpF19 + cashAndCashEqF32;
  let cashAndCashEqG32 = netIncCashAtEndF33;
  let netIncCashAtEndG33 =
    netCashUsedG30 + netCashUsedG25 + netCashFlowOpG19 + cashAndCashEqG32;
  let cashAndCashEqH32 = netIncCashAtEndG33;
  let netIncCashAtEndH33 =
    netCashUsedH30 + netCashUsedH25 + netCashFlowOpH19 + cashAndCashEqH32;
  let cashAndCashEqI32 = netIncCashAtEndH33;
  let netIncCashAtEndI33 =
    netCashUsedI30 + netCashUsedI25 + netCashFlowOpI19 + cashAndCashEqI32;
  let cashAndCashEqJ32 = netIncCashAtEndI33;
  let netIncCashAtEndJ33 =
    netCashUsedJ30 + netCashUsedJ25 + netCashFlowOpJ19 + cashAndCashEqJ32;

  let netIncInCashD34 = -cashAndCashEqD32 + netIncCashAtEndD33;
  let netIncInCashE34 = -cashAndCashEqE32 + netIncCashAtEndE33;
  let netIncInCashF34 = -cashAndCashEqF32 + netIncCashAtEndF33;
  let netIncInCashG34 = -cashAndCashEqG32 + netIncCashAtEndG33;
  let netIncInCashH34 = -cashAndCashEqH32 + netIncCashAtEndH33;
  let netIncInCashI34 = -cashAndCashEqI32 + netIncCashAtEndI33;
  let netIncInCashJ34 = -cashAndCashEqJ32 + netIncCashAtEndJ33;

  //   table bs
  let sundryDebD12 = salesC2 * 0.091;
  let sundryDebE12 = salesD2 * 0.12;
  let sundryDebF12 = salesE2 * 0.13;
  let sundryDebG12 = salesF2 * 0.16;
  let sundryDebH12 = salesG2 * 0.17;
  let sundryDebI12 = salesH2 * 0.175;
  let sundryDebJ12 = salesI2 * 0.178;

  let stockInTradeD13 = DEOpenStockD6;
  let stockInTradeE13 = DEOpenStockE6;
  let stockInTradeF13 = DEOpenStockF6;
  let stockInTradeG13 = DEOpenStockG6;
  let stockInTradeH13 = DEOpenStockH6;
  let stockInTradeI13 = DEOpenStockI6;
  let stockInTradeJ13 = DEOpenStockI6 * 1.1;

  let cashAndBalD15 = netIncCashAtEndD33;
  let cashAndBalE15 = netIncCashAtEndE33;
  let cashAndBalF15 = netIncCashAtEndF33;
  let cashAndBalG15 = netIncCashAtEndG33;
  let cashAndBalH15 = netIncCashAtEndH33;
  let cashAndBalI15 = netIncCashAtEndI33;
  let cashAndBalJ15 = netIncCashAtEndJ33;

  let currAssetsD11 = sundryDebD12 + stockInTradeD13 + cashAndBalD15;
  let currAssetsE11 = sundryDebE12 + stockInTradeE13 + cashAndBalE15;
  let currAssetsF11 = sundryDebF12 + stockInTradeF13 + cashAndBalF15;
  let currAssetsG11 = sundryDebG12 + stockInTradeG13 + cashAndBalG15;
  let currAssetsH11 = sundryDebH12 + stockInTradeH13 + cashAndBalH15;
  let currAssetsI11 = sundryDebI12 + stockInTradeI13 + cashAndBalI15;
  let currAssetsJ11 = sundryDebJ12 + stockInTradeJ13 + cashAndBalJ15;

  let totalD17 = netBlockD7 + investD9 + currAssetsD11;
  let totalE17 = netBlockE7 + investE9 + currAssetsE11;
  let totalF17 = netBlockF7 + investF9 + currAssetsF11;
  let totalG17 = netBlockG7 + investG9 + currAssetsG11;
  let totalH17 = netBlockH7 + investH9 + currAssetsH11;
  let totalI17 = netBlockI7 + investI9 + currAssetsI11;
  let totalJ17 = netBlockJ7 + investJ9 + currAssetsJ11;

  let diffInBsD38 = totalD35 - totalD17;
  let diffInBsE38 = totalE35 - totalE17;
  let diffInBsF38 = totalF35 - totalF17;
  let diffInBsG38 = totalG35 - totalG17;
  let diffInBsH38 = totalH35 - totalH17;
  let diffInBsI38 = totalI35 - totalI17;
  let diffInBsJ38 = totalJ35 - totalJ17;

  let diffInBsD39 =
    (sundryDebD12 + stockInTradeD13 + cashAndBalD15) / sundryCreatD31;
  let diffInBsE39 =
    (sundryDebE12 + stockInTradeE13 + cashAndBalE15) / sundryCreatE31;
  let diffInBsF39 =
    (sundryDebF12 + stockInTradeF13 + cashAndBalF15) / sundryCreatF31;
  let diffInBsG39 =
    (sundryDebG12 + stockInTradeG13 + cashAndBalG15) / sundryCreatG31;
  let diffInBsH39 =
    (sundryDebH12 + stockInTradeH13 + cashAndBalH15) / sundryCreatH31;
  let diffInBsI39 =
    (sundryDebI12 + stockInTradeI13 + cashAndBalI15) / sundryCreatI31;
  let diffInBsJ39 =
    (sundryDebJ12 + stockInTradeJ13 + cashAndBalJ15) / sundryCreatJ31;

  let tolTNWD40 =
    (termLoanFromBankD28 + currLiabilitiesD30 + sundryCreatD31) / capBalD25;
  let tolTNWE40 =
    (termLoanFromBankE28 + currLiabilitiesE30 + sundryCreatE31) / capBalE25;
  let tolTNWF40 =
    (termLoanFromBankF28 + currLiabilitiesF30 + sundryCreatF31) / capBalF25;
  let tolTNWG40 =
    (termLoanFromBankG28 + currLiabilitiesG30 + sundryCreatG31) / capBalG25;
  let tolTNWH40 =
    (termLoanFromBankH28 + currLiabilitiesH30 + sundryCreatH31) / capBalH25;
  let tolTNWI40 =
    (termLoanFromBankI28 + currLiabilitiesI30 + sundryCreatI31) / capBalI25;
  let tolTNWJ40 =
    (termLoanFromBankJ28 + currLiabilitiesJ30 + sundryCreatJ31) / capBalJ25;

  let deptToEqD41 = termLoanFromBankD28 / capBalD25;
  let deptToEqE41 = termLoanFromBankE28 / capBalE25;
  let deptToEqF41 = termLoanFromBankF28 / capBalF25;
  let deptToEqG41 = termLoanFromBankG28 / capBalG25;
  let deptToEqH41 = termLoanFromBankH28 / capBalH25;
  let deptToEqI41 = termLoanFromBankI28 / capBalI25;
  let deptToEqJ41 = termLoanFromBankJ28 / capBalJ25;
  // table 10

  let longTermDebtC2 = RemainingBalanceH2;
  let longTermDebtD2 = RemainingBalanceH3;
  let longTermDebtE2 = RemainingBalanceH4;
  let longTermDebtF2 = RemainingBalanceH5;
  let longTermDebtG2 = RemainingBalanceH6;
  let longTermDebtH2 = RemainingBalanceH7;
  let longTermDebtI2 = RemainingBalanceH8;

  let equityC3 = capBalD25;
  let equityD3 = capBalE25;
  let equityE3 = capBalF25;
  let equityF3 = capBalG25;
  let equityG3 = capBalH25;
  let equityH3 = capBalI25;
  let equityI3 = capBalJ25;

  let deptEqRatioC4 = longTermDebtC2 / equityC3;
  let deptEqRatioD4 = longTermDebtD2 / equityD3;
  let deptEqRatioE4 = longTermDebtE2 / equityE3;
  let deptEqRatioF4 = longTermDebtF2 / equityF3;
  let deptEqRatioG4 = longTermDebtG2 / equityG3;
  let deptEqRatioH4 = longTermDebtH2 / equityH3;
  let deptEqRatioI4 = longTermDebtI2 / equityI3;

  let maxDepEqC6 = Math.max(
    deptEqRatioC4,
    deptEqRatioD4,
    deptEqRatioE4,
    deptEqRatioF4,
    deptEqRatioG4,
    deptEqRatioH4,
    deptEqRatioI4
  );
  let minDepEqC7 = Math.min(
    deptEqRatioC4,
    deptEqRatioD4,
    deptEqRatioE4,
    deptEqRatioF4,
    deptEqRatioG4,
    deptEqRatioH4,
    deptEqRatioI4
  );
  let avgDepEqC8 =
    (deptEqRatioC4 +
      deptEqRatioD4 +
      deptEqRatioE4 +
      deptEqRatioF4 +
      deptEqRatioG4 +
      deptEqRatioH4 +
      deptEqRatioI4) /
    7;

  // table 7

  let profBefIntC2 = profBefoIntAndTaxC26;
  let depD2 = dpC4;
  let profBefIntAndDepTotalE2 = profBefIntC2 + depD2;
  let noiF2 = profitBeforeInterestC24;
  let instalAndINTDebtServiceG2 = InterestPaymentE2 + PrincipalPaymentF2;
  let dscrH2 = noiF2 / instalAndINTDebtServiceG2;

  let profBefIntC3 = profBefoIntAndTaxD26;
  let depD3 = dpD4;
  let profBefIntAndDepTotalE3 = profBefIntC3 + depD3;
  let noiF3 = profitBeforeInterestD24;
  let instalAndINTDebtServiceG3 = InterestPaymentE3 + PrincipalPaymentF3;
  let dscrH3 = noiF3 / instalAndINTDebtServiceG3;

  let profBefIntC4 = profBefoTaxE28;
  let depD4 = dpE4;
  let profBefIntAndDepTotalE4 = profBefIntC4 + depD4;
  let noiF4 = profitBeforeInterestE24;
  let instalAndINTDebtServiceG4 = InterestPaymentE4 + PrincipalPaymentF4;
  let dscrH4 = noiF4 / instalAndINTDebtServiceG4;

  let profBefIntC5 = profBefoTaxF28;
  let depD5 = dpF4;
  let profBefIntAndDepTotalE5 = profBefIntC5 + depD5;
  let noiF5 = profitBeforeInterestF24;
  let instalAndINTDebtServiceG5 = InterestPaymentE5 + PrincipalPaymentF5;
  let dscrH5 = noiF5 / instalAndINTDebtServiceG5;

  let profBefIntC6 = lessTax30PerG30;
  let depD6 = dpG4;
  let profBefIntAndDepTotalE6 = profBefIntC6 + depD6;
  let noiF6 = profitBeforeInterestG24;
  let instalAndINTDebtServiceG6 = InterestPaymentE6 + PrincipalPaymentF6;
  let dscrH6 = noiF6 / instalAndINTDebtServiceG6;

  let profBefIntC7 = lessTax30PerH30;
  let depD7 = dpH4;
  let profBefIntAndDepTotalE7 = profBefIntC7 + depD7;
  let noiF7 = profitBeforeInterestH24;
  let instalAndINTDebtServiceG7 = InterestPaymentE7 + PrincipalPaymentF7;
  let dscrH7 = noiF7 / instalAndINTDebtServiceG7;

  let profBefIntC8 = 0; //not available 2' c32
  let depD8 = dpI4;
  let profBefIntAndDepTotalE8 = profBefIntC8 + depD8;
  let noiF8 = profitBeforeInterestI24;
  let instalAndINTDebtServiceG8 = InterestPaymentE8 + PrincipalPaymentF8;
  let dscrH8 = noiF8 / instalAndINTDebtServiceG8;

  let maxDSCR = Math.max(
    dscrH2,
    dscrH3,
    dscrH4,
    dscrH5,
    dscrH6,
    dscrH7,
    dscrH8
  );
  let minDSCR = Math.min(
    dscrH2,
    dscrH3,
    dscrH4,
    dscrH5,
    dscrH6,
    dscrH7,
    dscrH8
  );
  let avgDSCR =
    (dscrH2 + dscrH3 + dscrH4 + dscrH5 + dscrH6 + dscrH7 + dscrH8) / 7;

  // table 9

  let totalOutsideLiabilitiesC2 = termLoanFromBankD28 + sundryCreatD31;
  let totalOutsideLiabilitiesD2 = termLoanFromBankE28 + sundryCreatE31;
  let totalOutsideLiabilitiesE2 = termLoanFromBankF28 + sundryCreatF31;
  let totalOutsideLiabilitiesF2 = termLoanFromBankG28 + sundryCreatG31;
  let totalOutsideLiabilitiesG2 = termLoanFromBankH28 + sundryCreatH31;
  let totalOutsideLiabilitiesH2 = termLoanFromBankI28 + sundryCreatI31;
  let totalOutsideLiabilitiesI2 = termLoanFromBankJ28 + sundryCreatJ31;

  let totalNetWorthCapitalC3 = equityC3;
  let totalNetWorthCapitalD3 = equityD3;
  let totalNetWorthCapitalE3 = equityE3;
  let totalNetWorthCapitalF3 = equityF3;
  let totalNetWorthCapitalG3 = equityG3;
  let totalNetWorthCapitalH3 = equityH3;
  let totalNetWorthCapitalI3 = equityI3;

  let currentRationC4 = totalOutsideLiabilitiesC2 / totalNetWorthCapitalC3;
  let currentRationD4 = totalOutsideLiabilitiesD2 / totalNetWorthCapitalD3;
  let currentRationE4 = totalOutsideLiabilitiesE2 / totalNetWorthCapitalE3;
  let currentRationF4 = totalOutsideLiabilitiesF2 / totalNetWorthCapitalF3;
  let currentRationG4 = totalOutsideLiabilitiesG2 / totalNetWorthCapitalG3;
  let currentRationH4 = totalOutsideLiabilitiesH2 / totalNetWorthCapitalH3;
  let currentRationI4 = totalOutsideLiabilitiesI2 / totalNetWorthCapitalI3;

  let maxTolTNW = Math.max(
    currentRationC4,
    currentRationD4,
    currentRationE4,
    currentRationF4,
    currentRationG4,
    currentRationH4,
    currentRationI4
  );
  let minTolTNW = Math.min(
    currentRationC4,
    currentRationD4,
    currentRationE4,
    currentRationF4,
    currentRationG4,
    currentRationH4,
    currentRationI4
  );
  let avgTolTNW = (maxTolTNW + minTolTNW) / 2;

  // table 13

  let grossRevenueC2 = salesC2;
  let grossRevenueD2 = salesD2;
  let grossRevenueE2 = salesE2;
  let grossRevenueF2 = salesF2;
  let grossRevenueG2 = salesG2;
  let grossRevenueH2 = salesH2;
  let grossRevenueI2 = salesI2;

  let grossProfitC3 = grossProfitC12;
  let grossProfitD3 = grossProfitD12;
  let grossProfitE3 = grossProfitE12;
  let grossProfitF3 = grossProfitF12;
  let grossProfitG3 = grossProfitG12;
  let grossProfitH3 = grossProfitH12;
  let grossProfitI3 = grossProfitI12;

  let netProfitAfterC4 = lessTax30PerC30;
  let netProfitAfterD4 = lessTax30PerD30;
  let netProfitAfterE4 = lessTax30PerE30;
  let netProfitAfterF4 = lessTax30PerF30;
  let netProfitAfterG4 = lessTax30PerG30;
  let netProfitAfterH4 = lessTax30PerH30;
  let netProfitAfterI4 = lessTax30PerI30;

  let netProfitToSalesC5 = (netProfitAfterC4 / grossRevenueC2) * 100;
  let netProfitToSalesD5 = (netProfitAfterD4 / grossRevenueD2) * 100;
  let netProfitToSalesE5 = (netProfitAfterE4 / grossRevenueE2) * 100;
  let netProfitToSalesF5 = (netProfitAfterF4 / grossRevenueF2) * 100;
  let netProfitToSalesG5 = (netProfitAfterG4 / grossRevenueG2) * 100;
  let netProfitToSalesH5 = (netProfitAfterH4 / grossRevenueH2) * 100;
  let netProfitToSalesI5 = (netProfitAfterI4 / grossRevenueI2) * 100;

  // table 4
  let termLoanFromBankC4 = borrowFromBankAmountD7;
  let termLoanFromBankD4 = 0;
  let termLoanFromBankE4 = 0;
  let termLoanFromBankF4 = 0;
  let termLoanFromBankG4 = 0;
  let termLoanFromBankH4 = 0;
  let termLoanFromBankI4 = 0;

  let intialCapitalContriPropC5 = ownContributionAmountD6;
  let intialCapitalContriPropD5 = 0;
  let intialCapitalContriPropE5 = 0;
  let intialCapitalContriPropF5 = 0;
  let intialCapitalContriPropG5 = 0;
  let intialCapitalContriPropH5 = 0;
  let intialCapitalContriPropI5 = 0;

  let netProfitAfterTaxC6 = lessTax30PerC30;
  let netProfitAfterTaxD6 = lessTax30PerD30;
  let netProfitAfterTaxE6 = lessTax30PerE30;
  let netProfitAfterTaxF6 = lessTax30PerF30;
  let netProfitAfterTaxG6 = lessTax30PerG30;
  let netProfitAfterTaxH6 = lessTax30PerH30;
  let netProfitAfterTaxI6 = lessTax30PerI30;

  let depreciationC7 = dpC4;
  let depreciationD7 = dpD4;
  let depreciationE7 = dpE4;
  let depreciationF7 = dpF4;
  let depreciationG7 = dpG4;
  let depreciationH7 = dpH4;
  let depreciationI7 = dpI4;

  let TotalC8 =
    termLoanFromBankC4 +
    intialCapitalContriPropC5 +
    netProfitAfterTaxC6 +
    depreciationC7;
  let TotalD8 =
    termLoanFromBankD4 +
    intialCapitalContriPropD5 +
    netProfitAfterTaxD6 +
    depreciationD7;
  let TotalE8 =
    termLoanFromBankE4 +
    intialCapitalContriPropE5 +
    netProfitAfterTaxE6 +
    depreciationE7;
  let TotalF8 =
    termLoanFromBankF4 +
    intialCapitalContriPropF5 +
    netProfitAfterTaxF6 +
    depreciationF7;
  let TotalG8 =
    termLoanFromBankG4 +
    intialCapitalContriPropG5 +
    netProfitAfterTaxG6 +
    depreciationG7;
  let TotalH8 =
    termLoanFromBankH4 +
    intialCapitalContriPropH5 +
    netProfitAfterTaxH6 +
    depreciationH7;
  let TotalI8 =
    termLoanFromBankI4 +
    intialCapitalContriPropI5 +
    netProfitAfterTaxI6 +
    depreciationI7;

  let additionInFixedAssetsC11 = totalProjectCostC3;
  let additionInFixedAssetsD11 = 0;
  let additionInFixedAssetsE11 = 0;
  let additionInFixedAssetsF11 = 0;
  let additionInFixedAssetsG11 = 0;
  let additionInFixedAssetsH11 = 0;
  let additionInFixedAssetsI11 = 0;

  let repayamentOfTermLoanC12 = TotalInstallmentG2;
  let repayamentOfTermLoanD12 = repayamentOfTermLoanC12;
  let repayamentOfTermLoanE12 = repayamentOfTermLoanD12;
  let repayamentOfTermLoanF12 = repayamentOfTermLoanE12;
  let repayamentOfTermLoanG12 = repayamentOfTermLoanF12;
  let repayamentOfTermLoanH12 = repayamentOfTermLoanG12;
  let repayamentOfTermLoanI12 = repayamentOfTermLoanH12;

  // table 4

  let changesInWorkingCapitalC13 =
    sundryDebD12 + stockInTradeD13 - sundryCreatD31;
  let changesInWorkingCapitalD13 =
    sundryDebE12 +
    stockInTradeE13 -
    sundryCreatE31 -
    changesInWorkingCapitalC13;

  let changesInWorkingCapitalE13 =
    sundryDebF12 +
    stockInTradeF13 -
    sundryCreatF31 -
    (sundryDebE12 + stockInTradeE13 - sundryCreatE31);

  let changesInWorkingCapitalF13 =
    sundryDebG12 +
    stockInTradeG13 -
    sundryCreatG31 -
    (sundryDebF12 + stockInTradeF13 - sundryCreatF31);

  let changesInWorkingCapitalG13 =
    sundryDebH12 +
    stockInTradeH13 -
    sundryCreatH31 -
    (sundryDebG12 + stockInTradeG13 - sundryCreatG31);
  let changesInWorkingCapitalH13 =
    sundryDebI12 +
    stockInTradeI13 -
    sundryCreatI31 -
    (sundryDebH12 + stockInTradeH13 - sundryCreatH31);
  let changesInWorkingCapitalI13 =
    sundryDebJ12 +
    stockInTradeJ13 -
    sundryCreatJ31 -
    (sundryDebI12 + stockInTradeI13 - sundryCreatI31);

  let drawingsC14 = lessDrawingsD24;
  let drawingsD14 = lessDrawingsE24;
  let drawingsE14 = lessDrawingsF24;
  let drawingsF14 = lessDrawingsG24;
  let drawingsG14 = lessDrawingsH24;
  let drawingsH14 = lessDrawingsI24;
  let drawingsI14 = lessDrawingsJ24;

  let inCreaseInInvestmentC15 = investD9;
  let inCreaseInInvestmentD15 = investE9 - investD9;
  let inCreaseInInvestmentE15 = investF9 - investE9;
  let inCreaseInInvestmentF15 = investG9 - investF9;
  let inCreaseInInvestmentG15 = investH9 - investG9;
  let inCreaseInInvestmentH15 = investI9 - investH9;
  let inCreaseInInvestmentI15 = investJ9 - investI9;

  let totalC16 =
    additionInFixedAssetsC11 +
    repayamentOfTermLoanC12 +
    changesInWorkingCapitalC13 +
    drawingsC14 +
    inCreaseInInvestmentC15;
  let totalD16 =
    additionInFixedAssetsD11 +
    repayamentOfTermLoanD12 +
    changesInWorkingCapitalD13 +
    drawingsD14 +
    inCreaseInInvestmentD15;
  let totalE16 =
    additionInFixedAssetsE11 +
    repayamentOfTermLoanE12 +
    changesInWorkingCapitalE13 +
    drawingsE14 +
    inCreaseInInvestmentE15;
  let totalF16 =
    additionInFixedAssetsF11 +
    repayamentOfTermLoanF12 +
    changesInWorkingCapitalF13 +
    drawingsF14 +
    inCreaseInInvestmentF15;
  let totalG16 =
    additionInFixedAssetsG11 +
    repayamentOfTermLoanG12 +
    changesInWorkingCapitalG13 +
    drawingsG14 +
    inCreaseInInvestmentG15;
  let totalH16 =
    additionInFixedAssetsH11 +
    repayamentOfTermLoanH12 +
    changesInWorkingCapitalH13 +
    drawingsH14 +
    inCreaseInInvestmentH15;
  let totalI16 =
    additionInFixedAssetsI11 +
    repayamentOfTermLoanI12 +
    changesInWorkingCapitalI13 +
    drawingsI14 +
    inCreaseInInvestmentI15;

  let OpeningBalanceC18 = 0;
  let SurplusC19 = TotalC8 - totalC16;
  let ClosingBalanceC20 = OpeningBalanceC18 + SurplusC19;

  let OpeningBalanceD18 = ClosingBalanceC20;
  let SurplusD19 = TotalD8 - totalD16;
  let ClosingBalanceD20 = OpeningBalanceD18 + SurplusD19;

  let OpeningBalanceE18 = ClosingBalanceD20;
  let SurplusE19 = TotalE8 - totalE16;
  let ClosingBalanceE20 = OpeningBalanceE18 + SurplusE19;

  let OpeningBalanceF18 = ClosingBalanceE20;
  let SurplusF19 = TotalF8 - totalF16;
  let ClosingBalanceF20 = OpeningBalanceF18 + SurplusF19;

  let OpeningBalanceG18 = ClosingBalanceF20;
  let SurplusG19 = TotalG8 - totalG16;
  let ClosingBalanceG20 = OpeningBalanceG18 + SurplusG19;

  let OpeningBalanceH18 = ClosingBalanceG20;
  let SurplusH19 = TotalH8 - totalH16;
  let ClosingBalanceH20 = OpeningBalanceH18 + SurplusH19;

  let OpeningBalanceI18 = ClosingBalanceH20;
  let SurplusI19 = TotalI8 - totalI16;
  let ClosingBalanceI20 = OpeningBalanceI18 + SurplusI19;

  // table 8
  let currAssetsC2 = sundryDebD12 + stockInTradeD13 + cashAndBalD15;
  let currAssetsD2 = sundryDebE12 + stockInTradeE13 + cashAndBalE15;
  let currAssetsE2 = sundryDebF12 + stockInTradeF13 + cashAndBalF15;
  let currAssetsF2 = sundryDebG12 + stockInTradeG13 + cashAndBalG15;
  let currAssetsG2 = sundryDebH12 + stockInTradeH13 + cashAndBalH15;
  let currAssetsH2 = sundryDebI12 + stockInTradeI13 + cashAndBalI15;
  let currAssetsI2 = sundryDebJ12 + stockInTradeJ13 + cashAndBalJ15;

  let currLiabitiesC3 = sundryCreatD31;
  let currLiabitiesD3 = sundryCreatE31;
  let currLiabitiesE3 = sundryCreatF31;
  let currLiabitiesF3 = sundryCreatG31;
  let currLiabitiesG3 = sundryCreatH31;
  let currLiabitiesH3 = sundryCreatI31;
  let currLiabitiesI3 = sundryCreatJ31;

  let currRatioC4 = currAssetsC2 / currLiabitiesC3;
  let currRatioD4 = currAssetsD2 / currLiabitiesD3;
  let currRatioE4 = currAssetsE2 / currLiabitiesE3;
  let currRatioF4 = currAssetsF2 / currLiabitiesF3;
  let currRatioG4 = currAssetsG2 / currLiabitiesG3;
  let currRatioH4 = currAssetsH2 / currLiabitiesH3;
  let currRatioI4 = currAssetsI2 / currLiabitiesI3;

  let maxCR = Math.max(
    currRatioC4,
    currRatioD4,
    currRatioE4,
    currRatioF4,
    currRatioG4,
    currRatioH4,
    currRatioI4
  );
  let minCR = Math.min(
    currRatioC4,
    currRatioD4,
    currRatioE4,
    currRatioF4,
    currRatioG4,
    currRatioH4,
    currRatioI4
  );
  let avgCR =
    (currRatioC4 +
      currRatioD4 +
      currRatioE4 +
      currRatioF4 +
      currRatioG4 +
      currRatioH4 +
      currRatioI4) /
    7;

  // table 14

  let totalSalesC3 = salesC2;
  let totalSalesD3 = salesD2;
  let totalSalesE3 = salesE2;
  let totalSalesF3 = salesF2;
  let totalSalesG3 = salesG2;
  let totalSalesH3 = salesH2;
  let totalSalesI3 = salesI2;

  let totalGrossProfitC4 = grossProfitC12;
  let totalGrossProfitD4 = grossProfitD12;
  let totalGrossProfitE4 = grossProfitE12;
  let totalGrossProfitF4 = grossProfitF12;
  let totalGrossProfitG4 = grossProfitG12;
  let totalGrossProfitH4 = grossProfitH12;
  let totalGrossProfitI4 = grossProfitI12;

  let gPRatioC5 = (totalGrossProfitC4 / totalSalesC3) * 100;
  let gPRatioD5 = (totalGrossProfitD4 / totalSalesD3) * 100;
  let gPRatioE5 = (totalGrossProfitE4 / totalSalesE3) * 100;
  let gPRatioF5 = (totalGrossProfitF4 / totalSalesF3) * 100;
  let gPRatioG5 = (totalGrossProfitG4 / totalSalesG3) * 100;
  let gPRatioH5 = (totalGrossProfitH4 / totalSalesH3) * 100;
  let gPRatioI5 = (totalGrossProfitI4 / totalSalesI3) * 100;

  let totalSalesC7 = totalSalesC3;
  let totalSalesD7 = totalSalesD3;
  let totalSalesE7 = totalSalesE3;
  let totalSalesF7 = totalSalesF3;
  let totalSalesG7 = totalSalesG3;
  let totalSalesH7 = totalSalesH3;
  let totalSalesI7 = totalSalesI3;

  let netProfitAfterTaxC8 = lessTax30PerC30;
  let netProfitAfterTaxD8 = lessTax30PerD30;
  let netProfitAfterTaxE8 = lessTax30PerE30;
  let netProfitAfterTaxF8 = lessTax30PerF30;
  let netProfitAfterTaxG8 = lessTax30PerG30;
  let netProfitAfterTaxH8 = lessTax30PerH30;
  let netProfitAfterTaxI8 = lessTax30PerI30;

  let nPRatioC9 = (netProfitAfterTaxC8 / totalSalesC7) * 100;
  let nPRatioD9 = (netProfitAfterTaxD8 / totalSalesD7) * 100;
  let nPRatioE9 = (netProfitAfterTaxE8 / totalSalesE7) * 100;
  let nPRatioF9 = (netProfitAfterTaxF8 / totalSalesF7) * 100;
  let nPRatioG9 = (netProfitAfterTaxG8 / totalSalesG7) * 100;
  let nPRatioH9 = (netProfitAfterTaxH8 / totalSalesH7) * 100;
  let nPRatioI9 = (netProfitAfterTaxI8 / totalSalesI7) * 100;

  let deptServiceCovRatioC10 = dscrH2;
  let deptServiceCovRatioD10 = dscrH3;
  let deptServiceCovRatioE10 = dscrH4;
  let deptServiceCovRatioF10 = dscrH5;
  let deptServiceCovRatioG10 = dscrH6;
  let deptServiceCovRatioH10 = dscrH7;
  let deptServiceCovRatioI10 = dscrH8;

  let currRatioC11 = currRatioC4;
  let currRatioD11 = currRatioD4;
  let currRatioE11 = currRatioE4;
  let currRatioF11 = currRatioF4;
  let currRatioG11 = currRatioG4;
  let currRatioH11 = currRatioH4;
  let currRatioI11 = currRatioI4;

  let quickAssetsC13 = sundryDebD12 + cashAndBalD15;
  let quickAssetsD13 = sundryDebE12 + cashAndBalE15;
  let quickAssetsE13 = sundryDebF12 + cashAndBalF15;
  let quickAssetsF13 = sundryDebG12 + cashAndBalG15;
  let quickAssetsG13 = sundryDebH12 + cashAndBalH15;
  let quickAssetsH13 = sundryDebI12 + cashAndBalI15;
  let quickAssetsI13 = sundryDebJ12 + cashAndBalJ15;

  let quickLiabilitiesC14 = sundryCreatD31;
  let quickLiabilitiesD14 = sundryCreatE31;
  let quickLiabilitiesE14 = sundryCreatF31;
  let quickLiabilitiesF14 = sundryCreatG31;
  let quickLiabilitiesG14 = sundryCreatH31;
  let quickLiabilitiesH14 = sundryCreatI31;
  let quickLiabilitiesI14 = sundryCreatJ31;

  let quickRatioC15 = quickAssetsC13 / quickLiabilitiesC14;
  let quickRatioD15 = quickAssetsD13 / quickLiabilitiesD14;
  let quickRatioE15 = quickAssetsE13 / quickLiabilitiesE14;
  let quickRatioF15 = quickAssetsF13 / quickLiabilitiesF14;
  let quickRatioG15 = quickAssetsG13 / quickLiabilitiesG14;
  let quickRatioH15 = quickAssetsH13 / quickLiabilitiesH14;
  let quickRatioI15 = quickAssetsI13 / quickLiabilitiesI14;

  let ebitC17 = profBefoIntAndTaxC26;
  let ebitD17 = profBefoIntAndTaxD26;
  let ebitE17 = profBefoIntAndTaxE26;
  let ebitF17 = profBefoIntAndTaxF26;
  let ebitG17 = profBefoIntAndTaxG26;
  let ebitH17 = profBefoIntAndTaxH26;
  let ebitI17 = profBefoIntAndTaxI26;

  let capitalEmployedC18 = grossBlockD4 + sundryDebD12 + stockInTradeD13;
  let capitalEmployedD18 = grossBlockE4 + sundryDebE12 + stockInTradeE13;
  let capitalEmployedE18 = grossBlockF4 + sundryDebF12 + stockInTradeF13;
  let capitalEmployedF18 = grossBlockG4 + sundryDebG12 + stockInTradeG13;
  let capitalEmployedG18 = grossBlockH4 + sundryDebH12 + stockInTradeH13;
  let capitalEmployedH18 = grossBlockI4 + sundryDebI12 + stockInTradeI13;
  let capitalEmployedI18 = grossBlockJ4 + sundryDebJ12 + stockInTradeJ13;

  let rocC19 = (ebitC17 / capitalEmployedC18) * 100;
  let rocD19 = (ebitD17 / capitalEmployedD18) * 100;
  let rocE19 = (ebitE17 / capitalEmployedE18) * 100;
  let rocF19 = (ebitF17 / capitalEmployedF18) * 100;
  let rocG19 = (ebitG17 / capitalEmployedG18) * 100;
  let rocH19 = (ebitH17 / capitalEmployedH18) * 100;
  let rocI19 = (ebitI17 / capitalEmployedI18) * 100;

  let returnC21 = lessTax30PerC30;
  let returnD21 = lessTax30PerD30;
  let returnE21 = lessTax30PerE30;
  let returnF21 = lessTax30PerF30;
  let returnG21 = lessTax30PerG30;
  let returnH21 = lessTax30PerH30;
  let returnI21 = lessTax30PerI30;

  let netWorthC22 = capBalD25;
  let netWorthD22 = capBalE25;
  let netWorthE22 = capBalF25;
  let netWorthF22 = capBalG25;
  let netWorthG22 = capBalH25;
  let netWorthH22 = capBalI25;
  let netWorthI22 = capBalJ25;

  let returnOnNetWorthC23 = (returnC21 / netWorthC22) * 100;
  let returnOnNetWorthD23 = (returnD21 / netWorthD22) * 100;
  let returnOnNetWorthE23 = (returnE21 / netWorthE22) * 100;
  let returnOnNetWorthF23 = (returnF21 / netWorthF22) * 100;
  let returnOnNetWorthG23 = (returnG21 / netWorthG22) * 100;
  let returnOnNetWorthH23 = (returnH21 / netWorthH22) * 100;
  let returnOnNetWorthI23 = (returnI21 / netWorthI22) * 100;

  useEffect(() => {
    if (allQData?.input_info?.isGrowSlab)
      setTimeout(() => {
        const element = document.getElementById("gs-rename");
        element.innerHTML = element.innerHTML.replace("GROW-BAG", "GROW-SLAB");
        element.innerHTML = element.innerHTML.replace("Grow bag", "Grow slab");
        element.innerHTML = element.innerHTML.replace(
          "grow bags",
          "grow slabs"
        );
        element.innerHTML = element.innerHTML.replace(
          "Grow bags",
          "Grow slabs"
        );
        element.innerHTML = element.innerHTML.replace(
          "Grow Bags",
          "Grow Slabs"
        );
        element.innerHTML = element.innerHTML.replace("Grow Bag", "Grow Slab");
        element.innerHTML = element.innerHTML.replace("Growbag", "Growslab");
        element.innerHTML = element.innerHTML.replace("Growbags", "Growslabs");
        element.innerHTML = element.innerHTML.replace("growbags", "growslabs");
      }, 1000);
  }, [allQData]);
  return (
    <div id="gs-rename">
      {/* table 1 */}
      <>
        <div style={{ textAlign: "center" }}>
          <h3 style={{ textAlign: "center", fontSize: "25px" }}>
            {getHeading(italianBasilArray, bellPaperArray)}
          </h3>
        </div>
        <p
          className="fw-bold mt-4 mb-0 text-uppercase"
          style={{
            fontSize: "1rem",
          }}
        >
          SCHEDULE I - COST OF PROJECT & SOURCE OF FINANCE
        </p>
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={{ width: "2%" }}>Sr.</th>
              <th style={{ width: "49%" }}>A. COST OF PROJECT</th>
              <th style={{ width: "49%" }}>(Rs. In Lakhs)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{1}</td>
              <td>{getQuotationFor(allQData?.input_info)}</td>
              <td>{roundOffCostWithNoFraction(totalProjectCostC3)}</td>
            </tr>
            <tr>
              <td>{2}</td>
              <td>
                <b>
                  TOTAL COST OF PROJECT{" "}
                  {data?.fundingAmmountType == "postGST"
                    ? "(Inclusive of GST)"
                    : ""}
                </b>
              </td>
              <td>{roundOffCostWithNoFraction(totalProjectCostC3)}</td>
            </tr>
          </tbody>
        </table>

        <table style={{ width: "100%", marginTop: "15px" }}>
          <thead>
            <tr>
              <th style={{ width: "2%" }}>Sr.</th>
              <th style={{ width: "32.66%" }}>SOURCES OF FINANCE</th>
              <th style={{ width: "32.66%" }}>Percentage (%)</th>
              <th style={{ width: "32.66%" }}>(Rs. In Lakhs)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{1}</td>
              <td>Own Contribution by Proprietor</td>
              <td>{ownContributionPercentageC6}%</td>
              <td>{roundOffCostWithNoFraction(ownContributionAmountD6)}</td>
            </tr>
            <tr>
              <td>{2}</td>
              <td>Borrowings from the Bank</td>
              <td>{borrowFromBankPercentC7}%</td>
              <td>{roundOffCostWithNoFraction(borrowFromBankAmountD7)}</td>
            </tr>
          </tbody>
        </table>
      </>
      {/* table 2 */}
      <>
        <p
          className="fw-bold mt-4 mb-0 text-uppercase"
          style={{
            fontSize: "1rem",
          }}
        >
          Capacity Utilization of Sales
        </p>
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={{ width: "2%" }}>Sr.</th>
              <th style={{ width: "28%" }}>Particulars</th>
              <th style={{ width: "10%" }}>1st Year</th>
              <th style={{ width: "10%" }}>2nd Year</th>
              <th style={{ width: "10%" }}>3rd Year</th>
              <th style={{ width: "10%" }}>4th Year</th>
              <th style={{ width: "10%" }}>5th Year</th>
              <th style={{ width: "10%" }}>6th Year</th>
              <th style={{ width: "10%" }}>7th Year</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{(serial = 1)}</td>
              <td>Capacity Utilization</td>
              <td>{totalPer && totalPer * 100}%</td>
              <td>{totalPer && totalPer * 100}%</td>
              <td>{totalPer && totalPer * 100}%</td>
              <td>{totalPer && totalPer * 100}%</td>
              <td>{totalPer && totalPer * 100}%</td>
              <td>{totalPer && totalPer * 100}%</td>
              <td>{totalPer && totalPer * 100}%</td>
            </tr>
            <tr>
              <td>{++serial}</td>
              <td>Sales / Receipts </td>
              <td>{roundOffCostWithNoFraction(salesReceipts1)}</td>
              <td>{roundOffCostWithNoFraction(salesReceipts2)}</td>
              <td>{roundOffCostWithNoFraction(salesReceipts3)}</td>
              <td>{roundOffCostWithNoFraction(salesReceipts4)}</td>
              <td>{roundOffCostWithNoFraction(salesReceipts5)}</td>
              <td>{roundOffCostWithNoFraction(salesReceipts6)}</td>
              <td>{roundOffCostWithNoFraction(salesReceipts7)}</td>
            </tr>
          </tbody>
        </table>
        <div style={{ pageBreakInside: "avoid" }}>
          <p
            className="fw-bold mt-4 mb-0 text-uppercase"
            style={{
              fontSize: "1rem",
            }}
          >
            SCHEDULE II - PROJECTED PROFITABILITY STATEMENT
          </p>{" "}
          <table style={{ width: "100%" }}>
            <thead>
              <tr>
                <th style={{ width: "2%" }}>Sr.</th>
                <th style={{ width: "28%" }}>Particulars</th>
                <th style={{ width: "10%" }}>1st Year</th>
                <th style={{ width: "10%" }}>2nd Year</th>
                <th style={{ width: "10%" }}>3rd Year</th>
                <th style={{ width: "10%" }}>4th Year</th>
                <th style={{ width: "10%" }}>5th Year</th>
                <th style={{ width: "10%" }}>6th Year</th>
                <th style={{ width: "10%" }}>7th Year</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>A.</td>
                <td>Sales</td>
                <td>{roundOffCostWithNoFraction(salesC2)}</td>
                <td>{roundOffCostWithNoFraction(salesD2)}</td>
                <td>{roundOffCostWithNoFraction(salesE2)}</td>
                <td>{roundOffCostWithNoFraction(salesF2)}</td>
                <td>{roundOffCostWithNoFraction(salesG2)}</td>
                <td>{roundOffCostWithNoFraction(salesH2)}</td>
                <td>{roundOffCostWithNoFraction(salesI2)}</td>
              </tr>
              <tr>
                <td></td>
                <td>Closing Stock</td>
                <td>{roundOffCostWithNoFraction(closingStockC3)}</td>
                <td>{roundOffCostWithNoFraction(closingStockD3)}</td>
                <td>{roundOffCostWithNoFraction(closingStockE3)}</td>
                <td>{roundOffCostWithNoFraction(closingStockF3)}</td>
                <td>{roundOffCostWithNoFraction(closingStockG3)}</td>
                <td>{roundOffCostWithNoFraction(closingStockH3)}</td>
                <td>{roundOffCostWithNoFraction(closingStockI3)}</td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <b>Total</b>
                </td>
                <td>{roundOffCostWithNoFraction(salesAndClosingTotalC4)}</td>
                <td>{roundOffCostWithNoFraction(salesAndClosingTotalD4)}</td>
                <td>{roundOffCostWithNoFraction(salesAndClosingTotalE4)}</td>
                <td>{roundOffCostWithNoFraction(salesAndClosingTotalF4)}</td>
                <td>{roundOffCostWithNoFraction(salesAndClosingTotalG4)}</td>
                <td>{roundOffCostWithNoFraction(salesAndClosingTotalH4)}</td>
                <td>{roundOffCostWithNoFraction(salesAndClosingTotalI4)}</td>
              </tr>
              <tr>
                <td>B.</td>
                <td>
                  <b>Direct Expenses</b>
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td>Opening Stock</td>
                <td>{roundOffCostWithNoFraction(DEOpenStockC6)}</td>
                <td>{roundOffCostWithNoFraction(DEOpenStockD6)}</td>
                <td>{roundOffCostWithNoFraction(DEOpenStockE6)}</td>
                <td>{roundOffCostWithNoFraction(DEOpenStockF6)}</td>
                <td>{roundOffCostWithNoFraction(DEOpenStockG6)}</td>
                <td>{roundOffCostWithNoFraction(DEOpenStockH6)}</td>
                <td>{roundOffCostWithNoFraction(DEOpenStockI6)}</td>
              </tr>
              <tr>
                <td></td>
                <td>Purchase of Material</td>
                <td>{roundOffCostWithNoFraction(DEPurchaseAndMaterialC7)}</td>
                <td>{roundOffCostWithNoFraction(DEPurchaseAndMaterialD7)}</td>
                <td>{roundOffCostWithNoFraction(DEPurchaseAndMaterialE7)}</td>
                <td>{roundOffCostWithNoFraction(DEPurchaseAndMaterialF7)}</td>
                <td>{roundOffCostWithNoFraction(DEPurchaseAndMaterialG7)}</td>
                <td>{roundOffCostWithNoFraction(DEPurchaseAndMaterialH7)}</td>
                <td>{roundOffCostWithNoFraction(DEPurchaseAndMaterialI7)}</td>
              </tr>
              <tr>
                <td></td>
                <td>Wages & Labour Charges</td>
                <td>{roundOffCostWithNoFraction(DEWagesAndLobourC8)}</td>
                <td>{roundOffCostWithNoFraction(DEWagesAndLobourD8)}</td>
                <td>{roundOffCostWithNoFraction(DEWagesAndLobourE8)}</td>
                <td>{roundOffCostWithNoFraction(DEWagesAndLobourF8)}</td>
                <td>{roundOffCostWithNoFraction(DEWagesAndLobourG8)}</td>
                <td>{roundOffCostWithNoFraction(DEWagesAndLobourH8)}</td>
                <td>{roundOffCostWithNoFraction(DEWagesAndLobourI8)}</td>
              </tr>
              <tr>
                <td></td>
                <td>Power and Fuel</td>
                <td>{roundOffCostWithNoFraction(DEPowerAndFuelC9)}</td>
                <td>{roundOffCostWithNoFraction(DEPowerAndFuelD9)}</td>
                <td>{roundOffCostWithNoFraction(DEPowerAndFuelE9)}</td>
                <td>{roundOffCostWithNoFraction(DEPowerAndFuelF9)}</td>
                <td>{roundOffCostWithNoFraction(DEPowerAndFuelG9)}</td>
                <td>{roundOffCostWithNoFraction(DEPowerAndFuelH9)}</td>
                <td>{roundOffCostWithNoFraction(DEPowerAndFuelI9)}</td>
              </tr>
              <tr>
                <td></td>
                <td>Freight and Transport</td>
                <td>{roundOffCostWithNoFraction(DEFreightAndTransC10)}</td>
                <td>{roundOffCostWithNoFraction(DEFreightAndTransD10)}</td>
                <td>{roundOffCostWithNoFraction(DEFreightAndTransE10)}</td>
                <td>{roundOffCostWithNoFraction(DEFreightAndTransF10)}</td>
                <td>{roundOffCostWithNoFraction(DEFreightAndTransG10)}</td>
                <td>{roundOffCostWithNoFraction(DEFreightAndTransH10)}</td>
                <td>{roundOffCostWithNoFraction(DEFreightAndTransI10)}</td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <b>Total</b>
                </td>
                <td>
                  <b>{roundOffCostWithNoFraction(DETotalC11)}</b>
                </td>
                <td>
                  <b>{roundOffCostWithNoFraction(DETotalD11)}</b>
                </td>
                <td>
                  <b>{roundOffCostWithNoFraction(DETotalE11)}</b>
                </td>
                <td>
                  <b>{roundOffCostWithNoFraction(DETotalF11)}</b>
                </td>
                <td>
                  <b>{roundOffCostWithNoFraction(DETotalG11)}</b>
                </td>
                <td>
                  <b>{roundOffCostWithNoFraction(DETotalH11)}</b>
                </td>
                <td>
                  <b>{roundOffCostWithNoFraction(DETotalI11)}</b>
                </td>
              </tr>
              <tr>
                <td>C.</td>
                <td>
                  <b>Gross Profit (A-B)</b>
                </td>
                <td>
                  <b>{roundOffCostWithNoFraction(grossProfitC12)}</b>
                </td>
                <td>
                  <b>{roundOffCostWithNoFraction(grossProfitD12)}</b>
                </td>
                <td>
                  <b>{roundOffCostWithNoFraction(grossProfitE12)}</b>
                </td>
                <td>
                  <b>{roundOffCostWithNoFraction(grossProfitF12)}</b>
                </td>
                <td>
                  <b>{roundOffCostWithNoFraction(grossProfitG12)}</b>
                </td>
                <td>
                  <b>{roundOffCostWithNoFraction(grossProfitH12)}</b>
                </td>
                <td>
                  <b>{roundOffCostWithNoFraction(grossProfitI12)}</b>
                </td>
              </tr>
              <tr>
                <td>D.</td>
                <td>
                  <b>To Indirect Expenses</b>
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td>Printing & Stationary</td>
                <td>{roundOffCostWithNoFraction(printAndStationaryC14)}</td>
                <td>{roundOffCostWithNoFraction(printAndStationaryD14)}</td>
                <td>{roundOffCostWithNoFraction(printAndStationaryE14)}</td>
                <td>{roundOffCostWithNoFraction(printAndStationaryF14)}</td>
                <td>{roundOffCostWithNoFraction(printAndStationaryG14)}</td>
                <td>{roundOffCostWithNoFraction(printAndStationaryH14)}</td>
                <td>{roundOffCostWithNoFraction(printAndStationaryI14)}</td>
              </tr>
              <tr>
                <td></td>
                <td>Postage & Telephone</td>
                <td>{roundOffCostWithNoFraction(postageAndTelephoneC15)}</td>
                <td>{roundOffCostWithNoFraction(postageAndTelephoneD15)}</td>
                <td>{roundOffCostWithNoFraction(postageAndTelephoneE15)}</td>
                <td>{roundOffCostWithNoFraction(postageAndTelephoneF15)}</td>
                <td>{roundOffCostWithNoFraction(postageAndTelephoneG15)}</td>
                <td>{roundOffCostWithNoFraction(postageAndTelephoneH15)}</td>
                <td>{roundOffCostWithNoFraction(postageAndTelephoneI15)}</td>
              </tr>
              <tr>
                <td></td>
                <td>Travelling & Conveyance Exps</td>
                <td>
                  {roundOffCostWithNoFraction(travellingAndConveyanceExpsC16)}
                </td>
                <td>
                  {roundOffCostWithNoFraction(travellingAndConveyanceExpsD16)}
                </td>
                <td>
                  {roundOffCostWithNoFraction(travellingAndConveyanceExpsE16)}
                </td>
                <td>
                  {roundOffCostWithNoFraction(travellingAndConveyanceExpsF16)}
                </td>
                <td>
                  {roundOffCostWithNoFraction(travellingAndConveyanceExpsG16)}
                </td>
                <td>
                  {roundOffCostWithNoFraction(travellingAndConveyanceExpsH16)}
                </td>
                <td>
                  {roundOffCostWithNoFraction(travellingAndConveyanceExpsI16)}
                </td>
              </tr>
              <tr>
                <td></td>
                <td>Repairs & Maintainance</td>
                <td>{roundOffCostWithNoFraction(repairsAndMaintainanceC17)}</td>
                <td>{roundOffCostWithNoFraction(repairsAndMaintainanceD17)}</td>
                <td>{roundOffCostWithNoFraction(repairsAndMaintainanceE17)}</td>
                <td>{roundOffCostWithNoFraction(repairsAndMaintainanceF17)}</td>
                <td>{roundOffCostWithNoFraction(repairsAndMaintainanceG17)}</td>
                <td>{roundOffCostWithNoFraction(repairsAndMaintainanceH17)}</td>
                <td>{roundOffCostWithNoFraction(repairsAndMaintainanceI17)}</td>
              </tr>
              <tr>
                <td></td>
                <td>Professional Fees</td>
                <td>{roundOffCostWithNoFraction(professionalFeesC18)}</td>
                <td>{roundOffCostWithNoFraction(professionalFeesD18)}</td>
                <td>{roundOffCostWithNoFraction(professionalFeesE18)}</td>
                <td>{roundOffCostWithNoFraction(professionalFeesF18)}</td>
                <td>{roundOffCostWithNoFraction(professionalFeesG18)}</td>
                <td>{roundOffCostWithNoFraction(professionalFeesH18)}</td>
                <td>{roundOffCostWithNoFraction(professionalFeesI18)}</td>
              </tr>
              <tr>
                <td></td>
                <td>Advertisement</td>
                <td>{roundOffCostWithNoFraction(advertisementC19)}</td>
                <td>{roundOffCostWithNoFraction(advertisementD19)}</td>
                <td>{roundOffCostWithNoFraction(advertisementE19)}</td>
                <td>{roundOffCostWithNoFraction(advertisementF19)}</td>
                <td>{roundOffCostWithNoFraction(advertisementG19)}</td>
                <td>{roundOffCostWithNoFraction(advertisementH19)}</td>
                <td>{roundOffCostWithNoFraction(advertisementI19)}</td>
              </tr>
              <tr>
                <td></td>
                <td>Audit Fees</td>
                <td>{roundOffCostWithNoFraction(auditFeesC20)}</td>
                <td>{roundOffCostWithNoFraction(auditFeesD20)}</td>
                <td>{roundOffCostWithNoFraction(auditFeesE20)}</td>
                <td>{roundOffCostWithNoFraction(auditFeesF20)}</td>
                <td>{roundOffCostWithNoFraction(auditFeesG20)}</td>
                <td>{roundOffCostWithNoFraction(auditFeesH20)}</td>
                <td>{roundOffCostWithNoFraction(auditFeesI20)}</td>
              </tr>
              <tr>
                <td></td>
                <td>Insurance charges</td>
                <td>{roundOffCostWithNoFraction(insuranceChargesC21)}</td>
                <td>{roundOffCostWithNoFraction(insuranceChargesD21)}</td>
                <td>{roundOffCostWithNoFraction(insuranceChargesE21)}</td>
                <td>{roundOffCostWithNoFraction(insuranceChargesF21)}</td>
                <td>{roundOffCostWithNoFraction(insuranceChargesG21)}</td>
                <td>{roundOffCostWithNoFraction(insuranceChargesH21)}</td>
                <td>{roundOffCostWithNoFraction(insuranceChargesI21)}</td>
              </tr>
              <tr>
                <td></td>
                <td>Office Expenses</td>
                <td>{roundOffCostWithNoFraction(officeExpensesC22)}</td>
                <td>{roundOffCostWithNoFraction(officeExpensesD22)}</td>
                <td>{roundOffCostWithNoFraction(officeExpensesE22)}</td>
                <td>{roundOffCostWithNoFraction(officeExpensesF22)}</td>
                <td>{roundOffCostWithNoFraction(officeExpensesG22)}</td>
                <td>{roundOffCostWithNoFraction(officeExpensesH22)}</td>
                <td>{roundOffCostWithNoFraction(officeExpensesI22)}</td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <b>Total</b>
                </td>
                <td>{roundOffCostWithNoFraction(IETotalC23)}</td>
                <td>{roundOffCostWithNoFraction(IETotalD23)}</td>
                <td>{roundOffCostWithNoFraction(IETotalE23)}</td>
                <td>{roundOffCostWithNoFraction(IETotalF23)}</td>
                <td>{roundOffCostWithNoFraction(IETotalG23)}</td>
                <td>{roundOffCostWithNoFraction(IETotalH23)}</td>
                <td>{roundOffCostWithNoFraction(IETotalI23)}</td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <b> Profit Before Interest, Dep&Tax</b>
                </td>
                <td>{roundOffCostWithNoFraction(profitBeforeInterestC24)}</td>
                <td>{roundOffCostWithNoFraction(profitBeforeInterestD24)}</td>
                <td>{roundOffCostWithNoFraction(profitBeforeInterestE24)}</td>
                <td>{roundOffCostWithNoFraction(profitBeforeInterestF24)}</td>
                <td>{roundOffCostWithNoFraction(profitBeforeInterestG24)}</td>
                <td>{roundOffCostWithNoFraction(profitBeforeInterestH24)}</td>
                <td>{roundOffCostWithNoFraction(profitBeforeInterestI24)}</td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <b>Less:- Depreciation ( Sch V)</b>
                </td>
                <td>{roundOffCostWithNoFraction(lessDepC25)}</td>
                <td>{roundOffCostWithNoFraction(lessDepD25)}</td>
                <td>{roundOffCostWithNoFraction(lessDepE25)}</td>
                <td>{roundOffCostWithNoFraction(lessDepF25)}</td>
                <td>{roundOffCostWithNoFraction(lessDepG25)}</td>
                <td>{roundOffCostWithNoFraction(lessDepH25)}</td>
                <td>{roundOffCostWithNoFraction(lessDepI25)}</td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <b> Profit Before Interest & Tax</b>
                </td>
                <td>{roundOffCostWithNoFraction(profBefoIntAndTaxC26)}</td>
                <td>{roundOffCostWithNoFraction(profBefoIntAndTaxD26)}</td>
                <td>{roundOffCostWithNoFraction(profBefoIntAndTaxE26)}</td>
                <td>{roundOffCostWithNoFraction(profBefoIntAndTaxF26)}</td>
                <td>{roundOffCostWithNoFraction(profBefoIntAndTaxG26)}</td>
                <td>{roundOffCostWithNoFraction(profBefoIntAndTaxH26)}</td>
                <td>{roundOffCostWithNoFraction(profBefoIntAndTaxI26)}</td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <b>Less:- Interest on TL @ 9%</b>
                </td>
                <td>{roundOffCostWithNoFraction(profBefoIntAndTaxC27)}</td>
                <td>{roundOffCostWithNoFraction(profBefoIntAndTaxD27)}</td>
                <td>{roundOffCostWithNoFraction(profBefoIntAndTaxE27)}</td>
                <td>{roundOffCostWithNoFraction(profBefoIntAndTaxF27)}</td>
                <td>{roundOffCostWithNoFraction(profBefoIntAndTaxG27)}</td>
                <td>{roundOffCostWithNoFraction(profBefoIntAndTaxH27)}</td>
                <td>{roundOffCostWithNoFraction(profBefoIntAndTaxI27)}</td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <b>Net Profit</b>
                </td>
                <td>{roundOffCostWithNoFraction(profBefoTaxC28)}</td>
                <td>{roundOffCostWithNoFraction(profBefoTaxD28)}</td>
                <td>{roundOffCostWithNoFraction(profBefoTaxE28)}</td>
                <td>{roundOffCostWithNoFraction(profBefoTaxF28)}</td>
                <td>{roundOffCostWithNoFraction(profBefoTaxG28)}</td>
                <td>{roundOffCostWithNoFraction(profBefoTaxH28)}</td>
                <td>{roundOffCostWithNoFraction(profBefoTaxI28)}</td>
              </tr>
              {/* <tr>
              <td></td>
              <td>
                <b>Less; Tax 25%</b>
              </td>
              <td>{roundOffCostWithNoFraction(lessTax30PerC29)}</td>
              <td>{roundOffCostWithNoFraction(lessTax30PerD29)}</td>
              <td>{roundOffCostWithNoFraction(lessTax30PerE29)}</td>
              <td>{roundOffCostWithNoFraction(lessTax30PerF29)}</td>
              <td>{roundOffCostWithNoFraction(lessTax30PerG29)}</td>
              <td>{roundOffCostWithNoFraction(lessTax30PerH29)}</td>
              <td>{roundOffCostWithNoFraction(lessTax30PerI29)}</td>
            </tr>
            <tr>
              <td></td>
              <td>
                <b>Profit After Tax</b>
              </td>
              <td>{roundOffCostWithNoFraction(lessTax30PerC30)}</td>
              <td>{roundOffCostWithNoFraction(lessTax30PerD30)}</td>
              <td>{roundOffCostWithNoFraction(lessTax30PerE30)}</td>
              <td>{roundOffCostWithNoFraction(lessTax30PerF30)}</td>
              <td>{roundOffCostWithNoFraction(lessTax30PerG30)}</td>
              <td>{roundOffCostWithNoFraction(lessTax30PerH30)}</td>
              <td>{roundOffCostWithNoFraction(lessTax30PerI30)}</td>
            </tr> */}
            </tbody>
          </table>
        </div>
      </>
      {/* table bs */}
      <div style={{ pageBreakInside: "avoid" }}>
        <p
          className="fw-bold mt-4 mb-0 text-uppercase"
          style={{
            fontSize: "1rem",
          }}
        >
          SCHEDULE III- PROJECTED BALANCE SHEET
        </p>
        <table style={{ width: "100%", borderCollapse: "collapse" }} border="1">
          <thead>
            <tr>
              <th style={{ width: "5%" }}>Sr.</th>
              <th style={{ width: "25%" }}>Particulars</th>
              <th style={{ width: "10%" }}>1st Year</th>
              <th style={{ width: "10%" }}>2nd Year</th>
              <th style={{ width: "10%" }}>3rd Year</th>
              <th style={{ width: "10%" }}>4th Year</th>
              <th style={{ width: "10%" }}>5th Year</th>
              <th style={{ width: "10%" }}>6th Year</th>
              <th style={{ width: "10%" }}>7th Year</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <b>A.</b>
              </td>
              <td>
                <b>ASSETS:</b>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td>FIXED ASSETS</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td>Gross Block</td>
              <td>{roundOffCostWithNoFraction(grossBlockD4)}</td>
              <td>{roundOffCostWithNoFraction(grossBlockE4)}</td>
              <td>{roundOffCostWithNoFraction(grossBlockF4)}</td>
              <td>{roundOffCostWithNoFraction(grossBlockG4)}</td>
              <td>{roundOffCostWithNoFraction(grossBlockH4)}</td>
              <td>{roundOffCostWithNoFraction(grossBlockI4)}</td>
              <td>{roundOffCostWithNoFraction(grossBlockJ4)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Addition</td>
              <td>{roundOffCostWithNoFraction(additionD5)}</td>
              <td>{roundOffCostWithNoFraction(additionE5)}</td>
              <td>{roundOffCostWithNoFraction(additionF5)}</td>
              <td>{roundOffCostWithNoFraction(additionG5)}</td>
              <td>{roundOffCostWithNoFraction(additionH5)}</td>
              <td>{roundOffCostWithNoFraction(additionI5)}</td>
              <td>{roundOffCostWithNoFraction(additionJ5)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Less Dep</td>
              <td>{roundOffCostWithNoFraction(lessDepD6)}</td>
              <td>{roundOffCostWithNoFraction(lessDepE6)}</td>
              <td>{roundOffCostWithNoFraction(lessDepF6)}</td>
              <td>{roundOffCostWithNoFraction(lessDepG6)}</td>
              <td>{roundOffCostWithNoFraction(lessDepH6)}</td>
              <td>{roundOffCostWithNoFraction(lessDepI6)}</td>
              <td>{roundOffCostWithNoFraction(lessDepJ6)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Net Block</td>
              <td>{roundOffCostWithNoFraction(netBlockD7)}</td>
              <td>{roundOffCostWithNoFraction(netBlockE7)}</td>
              <td>{roundOffCostWithNoFraction(netBlockF7)}</td>
              <td>{roundOffCostWithNoFraction(netBlockG7)}</td>
              <td>{roundOffCostWithNoFraction(netBlockH7)}</td>
              <td>{roundOffCostWithNoFraction(netBlockI7)}</td>
              <td>{roundOffCostWithNoFraction(netBlockJ7)}</td>
            </tr>
            <tr>
              <td>
                <b>B.</b>
              </td>
              <td>
                <b>INVESTMENTS</b>
              </td>
              <td>{roundOffCostWithNoFraction(investD9)}</td>
              <td>{roundOffCostWithNoFraction(investE9)}</td>
              <td>{roundOffCostWithNoFraction(investF9)}</td>
              <td>{roundOffCostWithNoFraction(investG9)}</td>
              <td>{roundOffCostWithNoFraction(investH9)}</td>
              <td>{roundOffCostWithNoFraction(investI9)}</td>
              <td>{roundOffCostWithNoFraction(investJ9)}</td>
            </tr>
            <tr>
              <td>
                <b>C.</b>
              </td>
              <td>
                <b>CURRENT ASSETS</b>
              </td>
              <td>{roundOffCostWithNoFraction(currAssetsD11)}</td>
              <td>{roundOffCostWithNoFraction(currAssetsE11)}</td>
              <td>{roundOffCostWithNoFraction(currAssetsF11)}</td>
              <td>{roundOffCostWithNoFraction(currAssetsG11)}</td>
              <td>{roundOffCostWithNoFraction(currAssetsH11)}</td>
              <td>{roundOffCostWithNoFraction(currAssetsI11)}</td>
              <td>{roundOffCostWithNoFraction(currAssetsJ11)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Sundry Debtors</td>
              <td>{roundOffCostWithNoFraction(sundryDebD12)}</td>
              <td>{roundOffCostWithNoFraction(sundryDebE12)}</td>
              <td>{roundOffCostWithNoFraction(sundryDebF12)}</td>
              <td>{roundOffCostWithNoFraction(sundryDebG12)}</td>
              <td>{roundOffCostWithNoFraction(sundryDebH12)}</td>
              <td>{roundOffCostWithNoFraction(sundryDebI12)}</td>
              <td>{roundOffCostWithNoFraction(sundryDebJ12)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Stock in Trade</td>
              <td>{roundOffCostWithNoFraction(stockInTradeD13)}</td>
              <td>{roundOffCostWithNoFraction(stockInTradeE13)}</td>
              <td>{roundOffCostWithNoFraction(stockInTradeF13)}</td>
              <td>{roundOffCostWithNoFraction(stockInTradeG13)}</td>
              <td>{roundOffCostWithNoFraction(stockInTradeH13)}</td>
              <td>{roundOffCostWithNoFraction(stockInTradeI13)}</td>
              <td>{roundOffCostWithNoFraction(stockInTradeJ13)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Other Current Assets </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td>Cash & Bank Balance </td>
              <td>{roundOffCostWithNoFraction(cashAndBalD15)}</td>
              <td>{roundOffCostWithNoFraction(cashAndBalE15)}</td>
              <td>{roundOffCostWithNoFraction(cashAndBalF15)}</td>
              <td>{roundOffCostWithNoFraction(cashAndBalG15)}</td>
              <td>{roundOffCostWithNoFraction(cashAndBalH15)}</td>
              <td>{roundOffCostWithNoFraction(cashAndBalI15)}</td>
              <td>{roundOffCostWithNoFraction(cashAndBalJ15)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Total </td>
              <td>{roundOffCostWithNoFraction(totalD17)}</td>
              <td>{roundOffCostWithNoFraction(totalE17)}</td>
              <td>{roundOffCostWithNoFraction(totalF17)}</td>
              <td>{roundOffCostWithNoFraction(totalG17)}</td>
              <td>{roundOffCostWithNoFraction(totalH17)}</td>
              <td>{roundOffCostWithNoFraction(totalI17)}</td>
              <td>{roundOffCostWithNoFraction(totalJ17)}</td>
            </tr>
            <tr>
              <td>
                <b>D.</b>
              </td>
              <td>
                <b>CAPITAL & LIABILITIES :</b>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td>Capital Account</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td>Opening Balance</td>
              <td>{roundOffCostWithNoFraction(opBalD21)}</td>
              <td>{roundOffCostWithNoFraction(opBalE21)}</td>
              <td>{roundOffCostWithNoFraction(opBalF21)}</td>
              <td>{roundOffCostWithNoFraction(opBalG21)}</td>
              <td>{roundOffCostWithNoFraction(opBalH21)}</td>
              <td>{roundOffCostWithNoFraction(opBalI21)}</td>
              <td>{roundOffCostWithNoFraction(opBalJ21)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Add: Additions for the year</td>
              <td>{roundOffCostWithNoFraction(additionDetailsD22)}</td>
              <td>{roundOffCostWithNoFraction(additionDetailsE22)}</td>
              <td>{roundOffCostWithNoFraction(additionDetailsF22)}</td>
              <td>{roundOffCostWithNoFraction(additionDetailsG22)}</td>
              <td>{roundOffCostWithNoFraction(additionDetailsH22)}</td>
              <td>{roundOffCostWithNoFraction(additionDetailsI22)}</td>
              <td>{roundOffCostWithNoFraction(additionDetailsJ22)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Add : Net Profit After Tax</td>
              <td>{roundOffCostWithNoFraction(netProfD23)}</td>
              <td>{roundOffCostWithNoFraction(netProfE23)}</td>
              <td>{roundOffCostWithNoFraction(netProfF23)}</td>
              <td>{roundOffCostWithNoFraction(netProfG23)}</td>
              <td>{roundOffCostWithNoFraction(netProfH23)}</td>
              <td>{roundOffCostWithNoFraction(netProfI23)}</td>
              <td>{roundOffCostWithNoFraction(netProfJ23)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Less : Drawings</td>
              <td>{roundOffCostWithNoFraction(lessDrawingsD24)}</td>
              <td>{roundOffCostWithNoFraction(lessDrawingsE24)}</td>
              <td>{roundOffCostWithNoFraction(lessDrawingsF24)}</td>
              <td>{roundOffCostWithNoFraction(lessDrawingsG24)}</td>
              <td>{roundOffCostWithNoFraction(lessDrawingsH24)}</td>
              <td>{roundOffCostWithNoFraction(lessDrawingsI24)}</td>
              <td>{roundOffCostWithNoFraction(lessDrawingsJ24)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Capital Bal.</td>
              <td>{roundOffCostWithNoFraction(capBalD25)}</td>
              <td>{roundOffCostWithNoFraction(capBalE25)}</td>
              <td>{roundOffCostWithNoFraction(capBalF25)}</td>
              <td>{roundOffCostWithNoFraction(capBalG25)}</td>
              <td>{roundOffCostWithNoFraction(capBalH25)}</td>
              <td>{roundOffCostWithNoFraction(capBalI25)}</td>
              <td>{roundOffCostWithNoFraction(capBalJ25)}</td>
            </tr>
            <tr>
              <td>
                <b>E.</b>
              </td>
              <td>
                <b>SECURED LOANS</b>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td>Term loan from Bank ( Sch:VI)</td>
              <td>{roundOffCostWithNoFraction(termLoanFromBankD28)}</td>
              <td>{roundOffCostWithNoFraction(termLoanFromBankE28)}</td>
              <td>{roundOffCostWithNoFraction(termLoanFromBankF28)}</td>
              <td>{roundOffCostWithNoFraction(termLoanFromBankG28)}</td>
              <td>{roundOffCostWithNoFraction(termLoanFromBankH28)}</td>
              <td>{roundOffCostWithNoFraction(termLoanFromBankI28)}</td>
              <td>{roundOffCostWithNoFraction(termLoanFromBankJ28)}</td>
            </tr>

            <tr>
              <td></td>
              <td>CURRENT LIABILITIES</td>
              <td>{roundOffCostWithNoFraction(currLiabilitiesD30)}</td>
              <td>{roundOffCostWithNoFraction(currLiabilitiesE30)}</td>
              <td>{roundOffCostWithNoFraction(currLiabilitiesF30)}</td>
              <td>{roundOffCostWithNoFraction(currLiabilitiesG30)}</td>
              <td>{roundOffCostWithNoFraction(currLiabilitiesH30)}</td>
              <td>{roundOffCostWithNoFraction(currLiabilitiesI30)}</td>
              <td>{roundOffCostWithNoFraction(currLiabilitiesJ30)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Sundry Creditors</td>
              <td>{roundOffCostWithNoFraction(sundryCreatD31)}</td>
              <td>{roundOffCostWithNoFraction(sundryCreatE31)}</td>
              <td>{roundOffCostWithNoFraction(sundryCreatF31)}</td>
              <td>{roundOffCostWithNoFraction(sundryCreatG31)}</td>
              <td>{roundOffCostWithNoFraction(sundryCreatH31)}</td>
              <td>{roundOffCostWithNoFraction(sundryCreatI31)}</td>
              <td>{roundOffCostWithNoFraction(sundryCreatJ31)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Provision</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td>Other Current Liabilities</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td>Total</td>
              <td>{roundOffCostWithNoFraction(totalD35)}</td>
              <td>{roundOffCostWithNoFraction(totalE35)}</td>
              <td>{roundOffCostWithNoFraction(totalF35)}</td>
              <td>{roundOffCostWithNoFraction(totalG35)}</td>
              <td>{roundOffCostWithNoFraction(totalH35)}</td>
              <td>{roundOffCostWithNoFraction(totalI35)}</td>
              <td>{roundOffCostWithNoFraction(totalJ35)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Difference in Bs </td>
              <td>{diffInBsD38.toFixed(2)}</td>
              <td>{diffInBsE38.toFixed(2)}</td>
              <td>{diffInBsF38.toFixed(2)}</td>
              <td>{diffInBsG38.toFixed(2)}</td>
              <td>{diffInBsH38.toFixed(2)}</td>
              <td>{diffInBsI38.toFixed(2)}</td>
              <td>{diffInBsJ38.toFixed(2)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Current Ratio </td>
              <td>{diffInBsD39.toFixed(2)}</td>
              <td>{diffInBsE39.toFixed(2)}</td>
              <td>{diffInBsF39.toFixed(2)}</td>
              <td>{diffInBsG39.toFixed(2)}</td>
              <td>{diffInBsH39.toFixed(2)}</td>
              <td>{diffInBsI39.toFixed(2)}</td>
              <td>{diffInBsJ39.toFixed(2)}</td>
            </tr>
            <tr>
              <td></td>
              <td>TOL- TNW </td>
              <td>{tolTNWD40.toFixed(2)}</td>
              <td>{tolTNWE40.toFixed(2)}</td>
              <td>{tolTNWF40.toFixed(2)}</td>
              <td>{tolTNWG40.toFixed(2)}</td>
              <td>{tolTNWH40.toFixed(2)}</td>
              <td>{tolTNWI40.toFixed(2)}</td>
              <td>{tolTNWJ40.toFixed(2)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Debt to equity </td>
              <td>{deptToEqD41.toFixed(2)}</td>
              <td>{deptToEqE41.toFixed(2)}</td>
              <td>{deptToEqF41.toFixed(2)}</td>
              <td>{deptToEqG41.toFixed(2)}</td>
              <td>{deptToEqH41.toFixed(2)}</td>
              <td>{deptToEqI41.toFixed(2)}</td>
              <td>{deptToEqJ41.toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
      </div>
      {/* table CF */}
      <div style={{ pageBreakInside: "avoid" }}>
        <p
          className="fw-bold mt-4 mb-0 text-uppercase"
          style={{
            fontSize: "1rem",
          }}
        >
          Projected Cash Flow Statement
        </p>
        <table style={{ width: "100%", borderCollapse: "collapse" }} border="1">
          <thead>
            <tr>
              <th style={{ width: "5%" }}>Sr.</th>
              <th style={{ width: "25%" }}>Particulars</th>
              <th style={{ width: "10%" }}>1st Year</th>
              <th style={{ width: "10%" }}>2nd Year</th>
              <th style={{ width: "10%" }}>3rd Year</th>
              <th style={{ width: "10%" }}>4th Year</th>
              <th style={{ width: "10%" }}>5th Year</th>
              <th style={{ width: "10%" }}>6th Year</th>
              <th style={{ width: "10%" }}>7th Year</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <b>A.</b>
              </td>
              <td>
                <b>CASH FLOW FROM OPERATING ACTIVITIES:</b>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td>
                <b>Net Profit Before Tax</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netProfBefTaxD5)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netProfBefTaxE5)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netProfBefTaxF5)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netProfBefTaxG5)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netProfBefTaxH5)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netProfBefTaxI5)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netProfBefTaxJ5)}</b>
              </td>
            </tr>
            <tr>
              <td></td>
              <td>Adjustments for:</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td>Depreciation</td>
              <td>{roundOffCostWithNoFraction(depCFD7)}</td>
              <td>{roundOffCostWithNoFraction(depCFE7)}</td>
              <td>{roundOffCostWithNoFraction(depCFF7)}</td>
              <td>{roundOffCostWithNoFraction(depCFG7)}</td>
              <td>{roundOffCostWithNoFraction(depCFH7)}</td>
              <td>{roundOffCostWithNoFraction(depCFI7)}</td>
              <td>{roundOffCostWithNoFraction(depCFJ7)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Intrest & Finance Charges in Profit & Loss Account</td>
              <td>{roundOffCostWithNoFraction(IFCD8)}</td>
              <td>{roundOffCostWithNoFraction(IFCE8)}</td>
              <td>{roundOffCostWithNoFraction(IFCF8)}</td>
              <td>{roundOffCostWithNoFraction(IFCG8)}</td>
              <td>{roundOffCostWithNoFraction(IFCH8)}</td>
              <td>{roundOffCostWithNoFraction(IFCI8)}</td>
              <td>{roundOffCostWithNoFraction(IFCJ8)}</td>
            </tr>
            <tr>
              <td></td>
              <td>
                <b>Operating Profit before Working Capital Changes</b>
              </td>
              <td>{roundOffCostWithNoFraction(operatinProfitD9)}</td>
              <td>{roundOffCostWithNoFraction(operatinProfitE9)}</td>
              <td>{roundOffCostWithNoFraction(operatinProfitF9)}</td>
              <td>{roundOffCostWithNoFraction(operatinProfitG9)}</td>
              <td>{roundOffCostWithNoFraction(operatinProfitH9)}</td>
              <td>{roundOffCostWithNoFraction(operatinProfitI9)}</td>
              <td>{roundOffCostWithNoFraction(operatinProfitJ9)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Adjustments for:</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td>Decrease/(Increase) in Receivables</td>
              <td>{roundOffCostWithNoFraction(decInReciveblesD11)}</td>
              <td>{roundOffCostWithNoFraction(decInReciveblesE11)}</td>
              <td>{roundOffCostWithNoFraction(decInReciveblesF11)}</td>
              <td>{roundOffCostWithNoFraction(decInReciveblesG11)}</td>
              <td>{roundOffCostWithNoFraction(decInReciveblesH11)}</td>
              <td>{roundOffCostWithNoFraction(decInReciveblesI11)}</td>
              <td>{roundOffCostWithNoFraction(decInReciveblesJ11)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Decrease/(Increase) in Inventories</td>
              <td>{roundOffCostWithNoFraction(decInInventoriesD12)}</td>
              <td>{roundOffCostWithNoFraction(decInInventoriesE12)}</td>
              <td>{roundOffCostWithNoFraction(decInInventoriesF12)}</td>
              <td>{roundOffCostWithNoFraction(decInInventoriesG12)}</td>
              <td>{roundOffCostWithNoFraction(decInInventoriesH12)}</td>
              <td>{roundOffCostWithNoFraction(decInInventoriesI12)}</td>
              <td>{roundOffCostWithNoFraction(decInInventoriesJ12)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Decrease/(Increase) in Current Assets</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
            </tr>
            <tr>
              <td></td>
              <td>Decrease/(Increase) in Current Liabilities</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
            </tr>
            <tr>
              <td></td>
              <td>Decrease/(Increase) in Current Provision</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
            </tr>
            <tr>
              <td></td>
              <td>Decrease/(Increase) in Sundry Creditors (Trade)</td>
              <td>{roundOffCostWithNoFraction(incTradeD16)}</td>
              <td>{roundOffCostWithNoFraction(incTradeE16)}</td>
              <td>{roundOffCostWithNoFraction(incTradeF16)}</td>
              <td>{roundOffCostWithNoFraction(incTradeG16)}</td>
              <td>{roundOffCostWithNoFraction(incTradeH16)}</td>
              <td>{roundOffCostWithNoFraction(incTradeI16)}</td>
              <td>{roundOffCostWithNoFraction(incTradeJ16)}</td>
            </tr>
            <tr>
              <td></td>
              <td>
                <b>Cash generated from operations</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(cashGenOpD17)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(cashGenOpE17)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(cashGenOpF17)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(cashGenOpG17)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(cashGenOpH17)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(cashGenOpI17)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(cashGenOpJ17)}</b>
              </td>
            </tr>
            {/* <tr>
              <td></td>
              <td>Income Tax Paid</td>
              <td>{roundOffCostWithNoFraction(incomeTaxPaidD18)}</td>
              <td>{roundOffCostWithNoFraction(incomeTaxPaidE18)}</td>
              <td>{roundOffCostWithNoFraction(incomeTaxPaidF18)}</td>
              <td>{roundOffCostWithNoFraction(incomeTaxPaidG18)}</td>
              <td>{roundOffCostWithNoFraction(incomeTaxPaidH18)}</td>
              <td>{roundOffCostWithNoFraction(incomeTaxPaidI18)}</td>
              <td>{roundOffCostWithNoFraction(incomeTaxPaidJ18)}</td>
            </tr> */}
            <tr>
              <td></td>
              <td>
                <b>Net Cash flow from operating activities</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netCashFlowOpD19)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netCashFlowOpE19)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netCashFlowOpF19)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netCashFlowOpG19)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netCashFlowOpH19)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netCashFlowOpI19)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netCashFlowOpJ19)}</b>
              </td>
            </tr>
            <tr>
              <td>
                <b>B.</b>
              </td>
              <td>
                <b>CASH FLOW FROM INVESTING ACTIVITIES</b>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td>Cash Credit</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td>Own Contribution for Business</td>
              <td>{roundOffCostWithNoFraction(netCashFlowOpD22)}</td>
              <td>{roundOffCostWithNoFraction(netCashFlowOpE22)}</td>
              <td>{roundOffCostWithNoFraction(netCashFlowOpF22)}</td>
              <td>{roundOffCostWithNoFraction(netCashFlowOpG22)}</td>
              <td>{roundOffCostWithNoFraction(netCashFlowOpH22)}</td>
              <td>{roundOffCostWithNoFraction(netCashFlowOpI22)}</td>
              <td>{roundOffCostWithNoFraction(netCashFlowOpJ22)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Purchase of Assets</td>
              <td>{roundOffCostWithNoFraction(purchaseOfAsetsD23)}</td>
              <td>{roundOffCostWithNoFraction(purchaseOfAsetsE23)}</td>
              <td>{roundOffCostWithNoFraction(purchaseOfAsetsF23)}</td>
              <td>{roundOffCostWithNoFraction(purchaseOfAsetsG23)}</td>
              <td>{roundOffCostWithNoFraction(purchaseOfAsetsH23)}</td>
              <td>{roundOffCostWithNoFraction(purchaseOfAsetsI23)}</td>
              <td>{roundOffCostWithNoFraction(purchaseOfAsetsJ23)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Investments & Other Non Current Assets</td>
              <td>{roundOffCostWithNoFraction(invAndNonCurrAsetsD24)}</td>
              <td>{roundOffCostWithNoFraction(invAndNonCurrAsetsE24)}</td>
              <td>{roundOffCostWithNoFraction(invAndNonCurrAsetsF24)}</td>
              <td>{roundOffCostWithNoFraction(invAndNonCurrAsetsG24)}</td>
              <td>{roundOffCostWithNoFraction(invAndNonCurrAsetsH24)}</td>
              <td>{roundOffCostWithNoFraction(invAndNonCurrAsetsI24)}</td>
              <td>{roundOffCostWithNoFraction(invAndNonCurrAsetsJ24)}</td>
            </tr>
            <tr>
              <td></td>
              <td>
                <b>Net Cash used in Investing activities</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netCashUsedD25)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netCashUsedE25)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netCashUsedF25)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netCashUsedG25)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netCashUsedH25)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netCashUsedI25)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netCashUsedJ25)}</b>
              </td>
            </tr>
            <tr>
              <td>
                <b>C.</b>
              </td>
              <td>
                <b>CASH FLOW FROM FINANCING ACTIVITIES</b>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td>Loan Disburment / Repayment</td>
              <td>{roundOffCostWithNoFraction(loanDisbursD27)}</td>
              <td>{roundOffCostWithNoFraction(loanDisbursE27)}</td>
              <td>{roundOffCostWithNoFraction(loanDisbursF27)}</td>
              <td>{roundOffCostWithNoFraction(loanDisbursG27)}</td>
              <td>{roundOffCostWithNoFraction(loanDisbursH27)}</td>
              <td>{roundOffCostWithNoFraction(loanDisbursI27)}</td>
              <td>{roundOffCostWithNoFraction(loanDisbursJ27)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Intrest paid for Term Loan Limit</td>
              <td>{roundOffCostWithNoFraction(itnPaidD28)}</td>
              <td>{roundOffCostWithNoFraction(itnPaidE28)}</td>
              <td>{roundOffCostWithNoFraction(itnPaidF28)}</td>
              <td>{roundOffCostWithNoFraction(itnPaidG28)}</td>
              <td>{roundOffCostWithNoFraction(itnPaidH28)}</td>
              <td>{roundOffCostWithNoFraction(itnPaidI28)}</td>
              <td>{roundOffCostWithNoFraction(itnPaidJ28)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Drawings</td>
              <td>{roundOffCostWithNoFraction(drawingsD29)}</td>
              <td>{roundOffCostWithNoFraction(drawingsE29)}</td>
              <td>{roundOffCostWithNoFraction(drawingsF29)}</td>
              <td>{roundOffCostWithNoFraction(drawingsG29)}</td>
              <td>{roundOffCostWithNoFraction(drawingsH29)}</td>
              <td>{roundOffCostWithNoFraction(drawingsI29)}</td>
              <td>{roundOffCostWithNoFraction(drawingsJ29)}</td>
            </tr>
            <tr>
              <td></td>
              <td>
                <b>Net Cash used in Financing Activities</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netCashUsedD30)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netCashUsedE30)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netCashUsedF30)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netCashUsedG30)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netCashUsedH30)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netCashUsedI30)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netCashUsedJ30)}</b>
              </td>
            </tr>
            <tr>
              <td></td>
              <td>
                <b>Net increase in cash & Cash Equivalents</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netIncCashD31)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netIncCashE31)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netIncCashF31)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netIncCashG31)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netIncCashH31)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netIncCashI31)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netIncCashJ31)}</b>
              </td>
            </tr>
            <tr>
              <td></td>
              <td>Cash and Cash equivalents as at the beginning of the year</td>
              <td>{roundOffCostWithNoFraction(cashAndCashEqD32)}</td>
              <td>{roundOffCostWithNoFraction(cashAndCashEqE32)}</td>
              <td>{roundOffCostWithNoFraction(cashAndCashEqF32)}</td>
              <td>{roundOffCostWithNoFraction(cashAndCashEqG32)}</td>
              <td>{roundOffCostWithNoFraction(cashAndCashEqH32)}</td>
              <td>{roundOffCostWithNoFraction(cashAndCashEqI32)}</td>
              <td>{roundOffCostWithNoFraction(cashAndCashEqJ32)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Cash and Cash equivalents as at the end of the year</td>
              <td>{roundOffCostWithNoFraction(netIncCashAtEndD33)}</td>
              <td>{roundOffCostWithNoFraction(netIncCashAtEndE33)}</td>
              <td>{roundOffCostWithNoFraction(netIncCashAtEndF33)}</td>
              <td>{roundOffCostWithNoFraction(netIncCashAtEndG33)}</td>
              <td>{roundOffCostWithNoFraction(netIncCashAtEndH33)}</td>
              <td>{roundOffCostWithNoFraction(netIncCashAtEndI33)}</td>
              <td>{roundOffCostWithNoFraction(netIncCashAtEndJ33)}</td>
            </tr>
            <tr>
              <td></td>
              <td>
                <b>Net increase in cash & Cash Equivalents</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netIncInCashD34)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netIncInCashE34)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netIncInCashF34)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netIncInCashG34)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netIncInCashH34)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netIncInCashI34)}</b>
              </td>
              <td>
                <b>{roundOffCostWithNoFraction(netIncInCashJ34)}</b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      {/* table 4 */}
      <div className="d-print-none">
        <p
          className="fw-bold mt-4 mb-0 text-uppercase"
          style={{
            fontSize: "1rem",
          }}
        >
          PROJECTED FUND FLOW STATEMENT
        </p>
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={{ width: "2%" }}>Sr.</th>
              <th style={{ width: "28%" }}>Particulars</th>
              <th style={{ width: "10%" }}>1st Year</th>
              <th style={{ width: "10%" }}>2nd Year</th>
              <th style={{ width: "10%" }}>3rd Year</th>
              <th style={{ width: "10%" }}>4th Year</th>
              <th style={{ width: "10%" }}>5th Year</th>
              <th style={{ width: "10%" }}>6th Year</th>
              <th style={{ width: "10%" }}>7th Year</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>A.</td>
              <td>
                <b>SOURCE OF FUNDS</b>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td>Term Loan from bank</td>
              <td>{roundOffCostWithNoFraction(termLoanFromBankC4)}</td>
              <td>{roundOffCostWithNoFraction(termLoanFromBankD4)}</td>
              <td>{roundOffCostWithNoFraction(termLoanFromBankE4)}</td>
              <td>{roundOffCostWithNoFraction(termLoanFromBankF4)}</td>
              <td>{roundOffCostWithNoFraction(termLoanFromBankG4)}</td>
              <td>{roundOffCostWithNoFraction(termLoanFromBankH4)}</td>
              <td>{roundOffCostWithNoFraction(termLoanFromBankI4)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Intial Capital Contribution Proprietor</td>
              <td>{roundOffCostWithNoFraction(intialCapitalContriPropC5)}</td>
              <td>{roundOffCostWithNoFraction(intialCapitalContriPropD5)}</td>
              <td>{roundOffCostWithNoFraction(intialCapitalContriPropE5)}</td>
              <td>{roundOffCostWithNoFraction(intialCapitalContriPropF5)}</td>
              <td>{roundOffCostWithNoFraction(intialCapitalContriPropG5)}</td>
              <td>{roundOffCostWithNoFraction(intialCapitalContriPropH5)}</td>
              <td>{roundOffCostWithNoFraction(intialCapitalContriPropI5)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Net Profit after Tax</td>
              <td>{roundOffCostWithNoFraction(netProfitAfterTaxC6)}</td>
              <td>{roundOffCostWithNoFraction(netProfitAfterTaxD6)}</td>
              <td>{roundOffCostWithNoFraction(netProfitAfterTaxE6)}</td>
              <td>{roundOffCostWithNoFraction(netProfitAfterTaxF6)}</td>
              <td>{roundOffCostWithNoFraction(netProfitAfterTaxG6)}</td>
              <td>{roundOffCostWithNoFraction(netProfitAfterTaxH6)}</td>
              <td>{roundOffCostWithNoFraction(netProfitAfterTaxI6)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Depreciation</td>
              <td>{roundOffCostWithNoFraction(depreciationC7)}</td>
              <td>{roundOffCostWithNoFraction(depreciationD7)}</td>
              <td>{roundOffCostWithNoFraction(depreciationE7)}</td>
              <td>{roundOffCostWithNoFraction(depreciationF7)}</td>
              <td>{roundOffCostWithNoFraction(depreciationG7)}</td>
              <td>{roundOffCostWithNoFraction(depreciationH7)}</td>
              <td>{roundOffCostWithNoFraction(depreciationI7)}</td>
            </tr>
            <tr>
              <td></td>
              <td>
                <b>Total</b>
              </td>
              <td>{roundOffCostWithNoFraction(TotalC8)}</td>
              <td>{roundOffCostWithNoFraction(TotalD8)}</td>
              <td>{roundOffCostWithNoFraction(TotalE8)}</td>
              <td>{roundOffCostWithNoFraction(TotalF8)}</td>
              <td>{roundOffCostWithNoFraction(TotalG8)}</td>
              <td>{roundOffCostWithNoFraction(TotalH8)}</td>
              <td>{roundOffCostWithNoFraction(TotalI8)}</td>
            </tr>
            <tr>
              <td>B.</td>
              <td>
                <b>APPLICATION OF FUNDS</b>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td>Addition in Fixed assets</td>
              <td>{roundOffCostWithNoFraction(additionInFixedAssetsC11)}</td>
              <td>{roundOffCostWithNoFraction(additionInFixedAssetsD11)}</td>
              <td>{roundOffCostWithNoFraction(additionInFixedAssetsE11)}</td>
              <td>{roundOffCostWithNoFraction(additionInFixedAssetsF11)}</td>
              <td>{roundOffCostWithNoFraction(additionInFixedAssetsG11)}</td>
              <td>{roundOffCostWithNoFraction(additionInFixedAssetsH11)}</td>
              <td>{roundOffCostWithNoFraction(additionInFixedAssetsI11)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Repayament of Term Loan</td>
              <td>{roundOffCostWithNoFraction(repayamentOfTermLoanC12)}</td>
              <td>{roundOffCostWithNoFraction(repayamentOfTermLoanD12)}</td>
              <td>{roundOffCostWithNoFraction(repayamentOfTermLoanE12)}</td>
              <td>{roundOffCostWithNoFraction(repayamentOfTermLoanF12)}</td>
              <td>{roundOffCostWithNoFraction(repayamentOfTermLoanG12)}</td>
              <td>{roundOffCostWithNoFraction(repayamentOfTermLoanH12)}</td>
              <td>{roundOffCostWithNoFraction(repayamentOfTermLoanI12)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Changes in working Capital</td>
              <td>{roundOffCostWithNoFraction(changesInWorkingCapitalC13)}</td>
              <td>{roundOffCostWithNoFraction(changesInWorkingCapitalD13)}</td>
              <td>{roundOffCostWithNoFraction(changesInWorkingCapitalE13)}</td>
              <td>{roundOffCostWithNoFraction(changesInWorkingCapitalF13)}</td>
              <td>{roundOffCostWithNoFraction(changesInWorkingCapitalG13)}</td>
              <td>{roundOffCostWithNoFraction(changesInWorkingCapitalH13)}</td>
              <td>{roundOffCostWithNoFraction(changesInWorkingCapitalI13)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Drawings</td>
              <td>{roundOffCostWithNoFraction(drawingsC14)}</td>
              <td>{roundOffCostWithNoFraction(drawingsD14)}</td>
              <td>{roundOffCostWithNoFraction(drawingsE14)}</td>
              <td>{roundOffCostWithNoFraction(drawingsF14)}</td>
              <td>{roundOffCostWithNoFraction(drawingsG14)}</td>
              <td>{roundOffCostWithNoFraction(drawingsH14)}</td>
              <td>{roundOffCostWithNoFraction(drawingsI14)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Increase in Investment</td>
              <td>{roundOffCostWithNoFraction(inCreaseInInvestmentC15)}</td>
              <td>{roundOffCostWithNoFraction(inCreaseInInvestmentD15)}</td>
              <td>{roundOffCostWithNoFraction(inCreaseInInvestmentE15)}</td>
              <td>{roundOffCostWithNoFraction(inCreaseInInvestmentF15)}</td>
              <td>{roundOffCostWithNoFraction(inCreaseInInvestmentG15)}</td>
              <td>{roundOffCostWithNoFraction(inCreaseInInvestmentH15)}</td>
              <td>{roundOffCostWithNoFraction(inCreaseInInvestmentI15)}</td>
            </tr>
            <tr>
              <td></td>
              <td>
                <b>Total</b>
              </td>
              <td>{roundOffCostWithNoFraction(totalC16)}</td>
              <td>{roundOffCostWithNoFraction(totalD16)}</td>
              <td>{roundOffCostWithNoFraction(totalE16)}</td>
              <td>{roundOffCostWithNoFraction(totalF16)}</td>
              <td>{roundOffCostWithNoFraction(totalG16)}</td>
              <td>{roundOffCostWithNoFraction(totalH16)}</td>
              <td>{roundOffCostWithNoFraction(totalI16)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Opening Balance</td>
              <td>{roundOffCostWithNoFraction(OpeningBalanceC18)}</td>
              <td>{roundOffCostWithNoFraction(OpeningBalanceD18)}</td>
              <td>{roundOffCostWithNoFraction(OpeningBalanceE18)}</td>
              <td>{roundOffCostWithNoFraction(OpeningBalanceF18)}</td>
              <td>{roundOffCostWithNoFraction(OpeningBalanceG18)}</td>
              <td>{roundOffCostWithNoFraction(OpeningBalanceH18)}</td>
              <td>{roundOffCostWithNoFraction(OpeningBalanceI18)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Surplus</td>
              <td>{roundOffCostWithNoFraction(SurplusC19)}</td>
              <td>{roundOffCostWithNoFraction(SurplusD19)}</td>
              <td>{roundOffCostWithNoFraction(SurplusE19)}</td>
              <td>{roundOffCostWithNoFraction(SurplusF19)}</td>
              <td>{roundOffCostWithNoFraction(SurplusG19)}</td>
              <td>{roundOffCostWithNoFraction(SurplusH19)}</td>
              <td>{roundOffCostWithNoFraction(SurplusI19)}</td>
            </tr>
            <tr>
              <td></td>
              <td>
                <b>Closing Balance</b>
              </td>
              <td>{roundOffCostWithNoFraction(ClosingBalanceC20)}</td>
              <td>{roundOffCostWithNoFraction(ClosingBalanceD20)}</td>
              <td>{roundOffCostWithNoFraction(ClosingBalanceE20)}</td>
              <td>{roundOffCostWithNoFraction(ClosingBalanceF20)}</td>
              <td>{roundOffCostWithNoFraction(ClosingBalanceG20)}</td>
              <td>{roundOffCostWithNoFraction(ClosingBalanceH20)}</td>
              <td>{roundOffCostWithNoFraction(ClosingBalanceI20)}</td>
            </tr>
          </tbody>
        </table>
      </div>
      {/* table 5 */}
      <div style={{ pageBreakInside: "avoid" }}>
        <p
          className="fw-bold mt-4 mb-0 text-uppercase"
          style={{
            fontSize: "1rem",
          }}
        >
          SCHEDULE IV- STATEMENT OF FIXED ASSETS AND DEPRECIATION
        </p>{" "}
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={{ width: "2%" }}>Sr.</th>
              <th style={{ width: "28%" }}>Particulars</th>
              <th style={{ width: "10%" }}>1st Year</th>
              <th style={{ width: "10%" }}>2nd Year</th>
              <th style={{ width: "10%" }}>3rd Year</th>
              <th style={{ width: "10%" }}>4th Year</th>
              <th style={{ width: "10%" }}>5th Year</th>
              <th style={{ width: "10%" }}>6th Year</th>
              <th style={{ width: "10%" }}>7th Year</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>Opening Balance</td>
              <td>{roundOffCostWithNoFraction(opBalC3)}</td>
              <td>{roundOffCostWithNoFraction(opBalD3)}</td>
              <td>{roundOffCostWithNoFraction(opBalE3)}</td>
              <td>{roundOffCostWithNoFraction(opBalF3)}</td>
              <td>{roundOffCostWithNoFraction(opBalG3)}</td>
              <td>{roundOffCostWithNoFraction(opBalH3)}</td>
              <td>{roundOffCostWithNoFraction(opBalI3)}</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Depreciation 10 %</td>
              <td>{roundOffCostWithNoFraction(dpC4)}</td>
              <td>{roundOffCostWithNoFraction(dpD4)}</td>
              <td>{roundOffCostWithNoFraction(dpE4)}</td>
              <td>{roundOffCostWithNoFraction(dpF4)}</td>
              <td>{roundOffCostWithNoFraction(dpG4)}</td>
              <td>{roundOffCostWithNoFraction(dpH4)}</td>
              <td>{roundOffCostWithNoFraction(dpI4)}</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Closing Balance</td>
              <td>{roundOffCostWithNoFraction(closingBalC5)}</td>
              <td>{roundOffCostWithNoFraction(closingBalD5)}</td>
              <td>{roundOffCostWithNoFraction(closingBalE5)}</td>
              <td>{roundOffCostWithNoFraction(closingBalF5)}</td>
              <td>{roundOffCostWithNoFraction(closingBalG5)}</td>
              <td>{roundOffCostWithNoFraction(closingBalH5)}</td>
              <td>{roundOffCostWithNoFraction(closingBalI5)}</td>
            </tr>
            <tr>
              <td>4</td>
              <td>
                <b>GROSS - OPENING WDV</b>
              </td>
              <td>{roundOffCostWithNoFraction(grossOpeningC7)}</td>
              <td>{roundOffCostWithNoFraction(grossOpeningD7)}</td>
              <td>{roundOffCostWithNoFraction(grossOpeningE7)}</td>
              <td>{roundOffCostWithNoFraction(grossOpeningF7)}</td>
              <td>{roundOffCostWithNoFraction(grossOpeningG7)}</td>
              <td>{roundOffCostWithNoFraction(grossOpeningH7)}</td>
              <td>{roundOffCostWithNoFraction(grossOpeningI7)}</td>
            </tr>
            <tr>
              <td>5</td>
              <td>
                <b>GROSS- TOTAL DEPRECIATION</b>
              </td>
              <td>{roundOffCostWithNoFraction(grossTotalDepC8)}</td>
              <td>{roundOffCostWithNoFraction(grossTotalDepD8)}</td>
              <td>{roundOffCostWithNoFraction(grossTotalDepE8)}</td>
              <td>{roundOffCostWithNoFraction(grossTotalDepF8)}</td>
              <td>{roundOffCostWithNoFraction(grossTotalDepG8)}</td>
              <td>{roundOffCostWithNoFraction(grossTotalDepH8)}</td>
              <td>{roundOffCostWithNoFraction(grossTotalDepI8)}</td>
            </tr>
            <tr>
              <td>6</td>
              <td>
                <b>GROSS- CLOSING WDV</b>
              </td>
              <td>{roundOffCostWithNoFraction(grossClosingC9)}</td>
              <td>{roundOffCostWithNoFraction(grossClosingD9)}</td>
              <td>{roundOffCostWithNoFraction(grossClosingE9)}</td>
              <td>{roundOffCostWithNoFraction(grossClosingF9)}</td>
              <td>{roundOffCostWithNoFraction(grossClosingG9)}</td>
              <td>{roundOffCostWithNoFraction(grossClosingH9)}</td>
              <td>{roundOffCostWithNoFraction(grossClosingI9)}</td>
            </tr>
          </tbody>
        </table>
      </div>
      {/* table 6 */}
      <div style={{ pageBreakInside: "avoid" }}>
        <p
          className="fw-bold mt-4 mb-0 text-uppercase"
          style={{
            fontSize: "1rem",
          }}
        >
          SCHEDULE V- STATEMENT SHOWING REPAYMENT OF TERM LOAN
        </p>
        <table style={{ width: "100%", marginBottom: "2px" }}>
          <thead>
            <tr>
              <th style={{ width: "2%" }}>Sr.</th>

              <th style={{ width: "32.66%" }}>Term Loan Amount</th>
              <th style={{ width: "32.66%" }}>Rate of Interest -( assumed)</th>
              <th style={{ width: "32.66%" }}>Repayment Period</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>
                <b>{roundOffCostWithNoFraction(termLoanAmmout)}</b>
              </td>
              <td>{rateOfIntC8}%</td>
              <td>
                {durationOfYearsC9} years ({durationOfYearsC9 * 12} months)
              </td>
            </tr>
          </tbody>
        </table>
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={{ width: "2%" }}>Sr.</th>
              <th style={{ width: "28%" }}>YEAR</th>

              <th style={{ width: "10%" }}>NO.OF INST.</th>
              <th style={{ width: "10%" }}>Outstanding Balance</th>
              <th style={{ width: "10%" }}>Interest Payment</th>
              <th style={{ width: "10%" }}>Principal Payment</th>
              <th style={{ width: "10%" }}>Total Installment</th>
              <th style={{ width: "10%" }}>Remaining Balance</th>
              <th style={{ width: "10%" }}>Net Interest Paid (%)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>YEAR I</td>

              <td>12</td>
              <td>{roundOffCostWithNoFraction(OutstandingBalanceD2)}</td>
              <td>{roundOffCostWithNoFraction(InterestPaymentE2)}</td>
              <td>{roundOffCostWithNoFraction(PrincipalPaymentF2)}</td>
              <td>{roundOffCostWithNoFraction(TotalInstallmentG2)}</td>
              <td>{roundOffCostWithNoFraction(RemainingBalanceH2)}</td>
              <td>{rateOfIntC8}</td>
            </tr>
            <tr>
              <td>2</td>
              <td>YEAR II</td>

              <td>12</td>
              <td>{roundOffCostWithNoFraction(OutstandingBalanceD3)}</td>
              <td>{roundOffCostWithNoFraction(InterestPaymentE3)}</td>
              <td>{roundOffCostWithNoFraction(PrincipalPaymentF3)}</td>
              <td>{roundOffCostWithNoFraction(TotalInstallmentG3)}</td>
              <td>{roundOffCostWithNoFraction(RemainingBalanceH3)}</td>
              <td>{rateOfIntC8}</td>
            </tr>
            <tr>
              <td>3</td>
              <td>YEAR III</td>

              <td>12</td>
              <td>{roundOffCostWithNoFraction(OutstandingBalanceD4)}</td>
              <td>{roundOffCostWithNoFraction(InterestPaymentE4)}</td>
              <td>{roundOffCostWithNoFraction(PrincipalPaymentF4)}</td>
              <td>{roundOffCostWithNoFraction(TotalInstallmentG4)}</td>
              <td>{roundOffCostWithNoFraction(RemainingBalanceH4)}</td>
              <td>{rateOfIntC8}</td>
            </tr>
            <tr>
              <td>4</td>
              <td>YEAR IV</td>

              <td>12</td>
              <td>{roundOffCostWithNoFraction(OutstandingBalanceD5)}</td>
              <td>{roundOffCostWithNoFraction(InterestPaymentE5)}</td>
              <td>{roundOffCostWithNoFraction(PrincipalPaymentF5)}</td>
              <td>{roundOffCostWithNoFraction(TotalInstallmentG5)}</td>
              <td>{roundOffCostWithNoFraction(RemainingBalanceH5)}</td>
              <td>{rateOfIntC8}</td>
            </tr>
            <tr>
              <td>5</td>
              <td>YEAR V</td>

              <td>12</td>
              <td>{roundOffCostWithNoFraction(OutstandingBalanceD6)}</td>
              <td>{roundOffCostWithNoFraction(InterestPaymentE6)}</td>
              <td>{roundOffCostWithNoFraction(PrincipalPaymentF6)}</td>
              <td>{roundOffCostWithNoFraction(TotalInstallmentG6)}</td>
              <td>{roundOffCostWithNoFraction(RemainingBalanceH6)}</td>
              <td>{rateOfIntC8}</td>
            </tr>
            <tr>
              <td>6</td>
              <td>YEAR VI</td>

              <td>12</td>
              <td>{roundOffCostWithNoFraction(OutstandingBalanceD7)}</td>
              <td>{roundOffCostWithNoFraction(InterestPaymentE7)}</td>
              <td>{roundOffCostWithNoFraction(PrincipalPaymentF7)}</td>
              <td>{roundOffCostWithNoFraction(TotalInstallmentG7)}</td>
              <td>{roundOffCostWithNoFraction(RemainingBalanceH7)}</td>
              <td>{rateOfIntC8}</td>
            </tr>
            <tr>
              <td>7</td>
              <td>YEAR VII</td>

              <td>12</td>
              <td>{roundOffCostWithNoFraction(OutstandingBalanceD8)}</td>
              <td>{roundOffCostWithNoFraction(InterestPaymentE8)}</td>
              <td>{roundOffCostWithNoFraction(PrincipalPaymentF8)}</td>
              <td>{roundOffCostWithNoFraction(TotalInstallmentG8)}</td>
              <td>{roundOffCostWithNoFraction(RemainingBalanceH8)}</td>
              <td>{rateOfIntC8}</td>
            </tr>
          </tbody>
        </table>
      </div>
      {/* table 7 */}
      <div style={{ pageBreakInside: "avoid" }}>
        <p
          className="fw-bold mt-4 mb-0 text-uppercase"
          style={{
            fontSize: "1rem",
          }}
        >
          SCHEDULE VI- STATEMENT SHOWING DEBT SERVICE RATIO(DSCR).
        </p>

        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={{ width: "2%" }}>Sr.</th>
              <th style={{ width: "28%" }}>YEAR</th>
              <th style={{ width: "11.66%" }}>PROFIT Before Int.</th>
              <th style={{ width: "11.66%" }}>DEPRECIATION</th>
              <th style={{ width: "11.66%" }}>TOTAL</th>
              <th style={{ width: "11.66%" }}>NOI</th>
              <th style={{ width: "11.66%" }}>INSTAL. & INT.</th>
              <th style={{ width: "11.66%" }}>D.S.C.R.</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>YEAR I</td>
              <td>{roundOffCostWithNoFraction(profBefIntC2)}</td>
              <td>{roundOffCostWithNoFraction(depD2)}</td>
              <td>{roundOffCostWithNoFraction(profBefIntAndDepTotalE2)}</td>
              <td>{roundOffCostWithNoFraction(noiF2)}</td>
              <td>{roundOffCostWithNoFraction(instalAndINTDebtServiceG2)}</td>
              <td>{dscrH2.toFixed(4)}</td>
            </tr>
            <tr>
              <td>2</td>
              <td>YEAR II</td>
              <td>{roundOffCostWithNoFraction(profBefIntC3)}</td>
              <td>{roundOffCostWithNoFraction(depD3)}</td>
              <td>{roundOffCostWithNoFraction(profBefIntAndDepTotalE3)}</td>
              <td>{roundOffCostWithNoFraction(noiF3)}</td>
              <td>{roundOffCostWithNoFraction(instalAndINTDebtServiceG3)}</td>
              <td>{dscrH3.toFixed(4)}</td>
            </tr>
            <tr>
              <td>3</td>
              <td>YEAR III</td>
              <td>{roundOffCostWithNoFraction(profBefIntC4)}</td>
              <td>{roundOffCostWithNoFraction(depD4)}</td>
              <td>{roundOffCostWithNoFraction(profBefIntAndDepTotalE4)}</td>
              <td>{roundOffCostWithNoFraction(noiF4)}</td>
              <td>{roundOffCostWithNoFraction(instalAndINTDebtServiceG4)}</td>
              <td>{dscrH4.toFixed(4)}</td>
            </tr>
            <tr>
              <td>4</td>
              <td>YEAR IV</td>
              <td>{roundOffCostWithNoFraction(profBefIntC5)}</td>
              <td>{roundOffCostWithNoFraction(depD5)}</td>
              <td>{roundOffCostWithNoFraction(profBefIntAndDepTotalE5)}</td>
              <td>{roundOffCostWithNoFraction(noiF5)}</td>
              <td>{roundOffCostWithNoFraction(instalAndINTDebtServiceG5)}</td>
              <td>{dscrH5.toFixed(4)}</td>
            </tr>
            <tr>
              <td>5</td>
              <td>YEAR V</td>
              <td>{roundOffCostWithNoFraction(profBefIntC6)}</td>
              <td>{roundOffCostWithNoFraction(depD6)}</td>
              <td>{roundOffCostWithNoFraction(profBefIntAndDepTotalE6)}</td>
              <td>{roundOffCostWithNoFraction(noiF6)}</td>
              <td>{roundOffCostWithNoFraction(instalAndINTDebtServiceG6)}</td>
              <td>{dscrH6.toFixed(4)}</td>
            </tr>
            <tr>
              <td>6</td>
              <td>YEAR VI</td>
              <td>{roundOffCostWithNoFraction(profBefIntC7)}</td>
              <td>{roundOffCostWithNoFraction(depD7)}</td>
              <td>{roundOffCostWithNoFraction(profBefIntAndDepTotalE7)}</td>
              <td>{roundOffCostWithNoFraction(noiF7)}</td>
              <td>{roundOffCostWithNoFraction(instalAndINTDebtServiceG7)}</td>
              <td>{dscrH7.toFixed(4)}</td>
            </tr>
            <tr>
              <td>7</td>
              <td>YEAR VII</td>
              <td>{roundOffCostWithNoFraction(profBefIntC8)}</td>
              <td>{roundOffCostWithNoFraction(depD8)}</td>
              <td>{roundOffCostWithNoFraction(profBefIntAndDepTotalE8)}</td>
              <td>{roundOffCostWithNoFraction(noiF8)}</td>
              <td>{roundOffCostWithNoFraction(instalAndINTDebtServiceG8)}</td>
              <td>{dscrH8.toFixed(4)}</td>
            </tr>
          </tbody>
        </table>
        <div
          style={{
            width: "40%",
            marginLeft: "auto",
            alignSelf: "end",
          }}
        >
          <table style={{ width: "100%" }}>
            <thead>
              <th style={{ width: "50%" }}></th>
              <th style={{ width: "50%" }}></th>
            </thead>
            <tbody>
              <tr>
                <td>
                  <b>MAXIMUM D.S.C.R.</b>
                </td>
                <td>
                  <b>{maxDSCR.toFixed(4)}</b>
                </td>
              </tr>
              <tr>
                <td>
                  <b>MINIMUM D.S.C.R.</b>
                </td>
                <td>
                  <b>{minDSCR.toFixed(4)}</b>
                </td>
              </tr>
              <tr>
                <td>
                  <b>AVERAGE D.S.C.R.</b>
                </td>
                <td>
                  <b>{avgDSCR.toFixed(4)}</b>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      {/* table 8 */}
      <div style={{ pageBreakInside: "avoid" }}>
        <p
          className="fw-bold mt-4 mb-0 text-uppercase"
          style={{
            fontSize: "1rem",
          }}
        >
          SCHEDULE VII- STATEMENT SHOWING CURRENT RATIO
        </p>

        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={{ width: "2%" }}>Sr.</th>
              <th style={{ width: "28%" }}>YEAR</th>
              <th style={{ width: "10%" }}>1st Year</th>
              <th style={{ width: "10%" }}>2nd Year</th>
              <th style={{ width: "10%" }}>3rd Year</th>
              <th style={{ width: "10%" }}>4th Year</th>
              <th style={{ width: "10%" }}>5th Year</th>
              <th style={{ width: "10%" }}>6th Year</th>
              <th style={{ width: "10%" }}>7th Year</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>A.</td>
              <td>CURRENT ASSETS</td>
              <td>{roundOffCostWithNoFraction(currAssetsC2)}</td>
              <td>{roundOffCostWithNoFraction(currAssetsD2)}</td>
              <td>{roundOffCostWithNoFraction(currAssetsE2)}</td>
              <td>{roundOffCostWithNoFraction(currAssetsF2)}</td>
              <td>{roundOffCostWithNoFraction(currAssetsG2)}</td>
              <td>{roundOffCostWithNoFraction(currAssetsH2)}</td>
              <td>{roundOffCostWithNoFraction(currAssetsI2)}</td>
            </tr>
            <tr>
              <td>B.</td>
              <td>CURRENT LIABILITIES</td>
              <td>{roundOffCostWithNoFraction(currLiabitiesC3)}</td>
              <td>{roundOffCostWithNoFraction(currLiabitiesD3)}</td>
              <td>{roundOffCostWithNoFraction(currLiabitiesE3)}</td>
              <td>{roundOffCostWithNoFraction(currLiabitiesF3)}</td>
              <td>{roundOffCostWithNoFraction(currLiabitiesG3)}</td>
              <td>{roundOffCostWithNoFraction(currLiabitiesH3)}</td>
              <td>{roundOffCostWithNoFraction(currLiabitiesI3)}</td>
            </tr>
            <tr>
              <td>C.</td>
              <td>CURRENT RATIO (A/B)</td>
              <td>{currRatioC4.toFixed(2)}</td>
              <td>{currRatioD4.toFixed(2)}</td>
              <td>{currRatioE4.toFixed(2)}</td>
              <td>{currRatioF4.toFixed(2)}</td>
              <td>{currRatioG4.toFixed(2)}</td>
              <td>{currRatioH4.toFixed(2)}</td>
              <td>{currRatioI4.toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
        <div
          style={{
            width: "40%",
            marginLeft: "auto",
            alignSelf: "end",
          }}
        >
          <table style={{ width: "100%" }}>
            <thead>
              <th style={{ width: "50%" }}></th>
              <th style={{ width: "50%" }}></th>
            </thead>
            <tbody>
              <tr>
                <td>
                  <b>MAXIMUM C.R.</b>
                </td>
                <td>
                  <b>{maxCR.toFixed(2)}</b>
                </td>
              </tr>
              <tr>
                <td>
                  <b>MINIMUM C.R.</b>
                </td>
                <td>
                  <b>{minCR.toFixed(2)}</b>
                </td>
              </tr>
              <tr>
                <td>
                  <b>AVERAGE C.R.</b>
                </td>
                <td>
                  <b>{avgCR.toFixed(2)}</b>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      {/* table 9 */}
      <div style={{ pageBreakInside: "avoid" }}>
        <p
          className="fw-bold mt-4 mb-0 text-uppercase"
          style={{
            fontSize: "1rem",
          }}
        >
          SCHEDULE VIII- STATEMENT SHOWING TOL/TNW RATIO
        </p>

        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={{ width: "2%" }}>Sr.</th>
              <th style={{ width: "28%" }}>YEAR</th>
              <th style={{ width: "10%" }}>1st Year</th>
              <th style={{ width: "10%" }}>2nd Year</th>
              <th style={{ width: "10%" }}>3rd Year</th>
              <th style={{ width: "10%" }}>4th Year</th>
              <th style={{ width: "10%" }}>5th Year</th>
              <th style={{ width: "10%" }}>6th Year</th>
              <th style={{ width: "10%" }}>7th Year</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>A.</td>
              <td>Total Outside Liabilities</td>
              <td>{roundOffCostWithNoFraction(totalOutsideLiabilitiesC2)}</td>
              <td>{roundOffCostWithNoFraction(totalOutsideLiabilitiesD2)}</td>
              <td>{roundOffCostWithNoFraction(totalOutsideLiabilitiesE2)}</td>
              <td>{roundOffCostWithNoFraction(totalOutsideLiabilitiesF2)}</td>
              <td>{roundOffCostWithNoFraction(totalOutsideLiabilitiesG2)}</td>
              <td>{roundOffCostWithNoFraction(totalOutsideLiabilitiesH2)}</td>
              <td>{roundOffCostWithNoFraction(totalOutsideLiabilitiesI2)}</td>
            </tr>
            <tr>
              <td>B.</td>
              <td>Total Net Worth/ Capital</td>
              <td>{roundOffCostWithNoFraction(totalNetWorthCapitalC3)}</td>
              <td>{roundOffCostWithNoFraction(totalNetWorthCapitalD3)}</td>
              <td>{roundOffCostWithNoFraction(totalNetWorthCapitalE3)}</td>
              <td>{roundOffCostWithNoFraction(totalNetWorthCapitalF3)}</td>
              <td>{roundOffCostWithNoFraction(totalNetWorthCapitalG3)}</td>
              <td>{roundOffCostWithNoFraction(totalNetWorthCapitalH3)}</td>
              <td>{roundOffCostWithNoFraction(totalNetWorthCapitalI3)}</td>
            </tr>
            <tr>
              <td>C.</td>
              <td>CURRENT RATIO (A/B)</td>
              <td>{currentRationC4.toFixed(4)}</td>
              <td>{currentRationD4.toFixed(4)}</td>
              <td>{currentRationE4.toFixed(4)}</td>
              <td>{currentRationF4.toFixed(4)}</td>
              <td>{currentRationG4.toFixed(4)}</td>
              <td>{currentRationH4.toFixed(4)}</td>
              <td>{currentRationI4.toFixed(4)}</td>
            </tr>
          </tbody>
        </table>
        <div
          style={{
            width: "40%",
            marginLeft: "auto",
            alignSelf: "end",
          }}
        >
          <table style={{ width: "100%" }}>
            <thead>
              <th style={{ width: "50%" }}></th>
              <th style={{ width: "50%" }}></th>
            </thead>
            <tbody>
              <tr>
                <td>
                  <b>MAXIMUM TOL/TNW</b>
                </td>
                <td>
                  <b>{maxTolTNW.toFixed(4)}</b>
                </td>
              </tr>
              <tr>
                <td>
                  <b>MINIMUM TOL/TNW</b>
                </td>
                <td>
                  <b>{minTolTNW.toFixed(4)}</b>
                </td>
              </tr>
              <tr>
                <td>
                  <b>AVERAGE TOL/TNW</b>
                </td>
                <td>
                  <b>{avgTolTNW.toFixed(4)}</b>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      {/* table 10 */}
      <div style={{ pageBreakInside: "avoid" }}>
        <p
          className="fw-bold mt-4 mb-0 text-uppercase"
          style={{
            fontSize: "1rem",
          }}
        >
          SCHEDULE IX- STATEMENT SHOWING DEBT TO EQUITY RATIO (A/B)
        </p>{" "}
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={{ width: "2%" }}>Sr.</th>
              <th style={{ width: "28%" }}>YEAR</th>
              <th style={{ width: "10%" }}>1st Year</th>
              <th style={{ width: "10%" }}>2nd Year</th>
              <th style={{ width: "10%" }}>3rd Year</th>
              <th style={{ width: "10%" }}>4th Year</th>
              <th style={{ width: "10%" }}>5th Year</th>
              <th style={{ width: "10%" }}>6th Year</th>
              <th style={{ width: "10%" }}>7th Year</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>A.</td>
              <td>Long Term Debt</td>
              <td>{roundOffCostWithNoFraction(longTermDebtC2)}</td>
              <td>{roundOffCostWithNoFraction(longTermDebtD2)}</td>
              <td>{roundOffCostWithNoFraction(longTermDebtE2)}</td>
              <td>{roundOffCostWithNoFraction(longTermDebtF2)}</td>
              <td>{roundOffCostWithNoFraction(longTermDebtG2)}</td>
              <td>{roundOffCostWithNoFraction(longTermDebtH2)}</td>
              <td>{roundOffCostWithNoFraction(longTermDebtI2)}</td>
            </tr>
            <tr>
              <td>B.</td>
              <td>Equity</td>
              <td>{roundOffCostWithNoFraction(equityC3)}</td>
              <td>{roundOffCostWithNoFraction(equityD3)}</td>
              <td>{roundOffCostWithNoFraction(equityE3)}</td>
              <td>{roundOffCostWithNoFraction(equityF3)}</td>
              <td>{roundOffCostWithNoFraction(equityG3)}</td>
              <td>{roundOffCostWithNoFraction(equityH3)}</td>
              <td>{roundOffCostWithNoFraction(equityI3)}</td>
            </tr>
            <tr>
              <td>C.</td>
              <td>DEBT- EQUITY RATIO (A/B)</td>
              <td>{deptEqRatioC4.toFixed(4)}</td>
              <td>{deptEqRatioD4.toFixed(4)}</td>
              <td>{deptEqRatioE4.toFixed(4)}</td>
              <td>{deptEqRatioF4.toFixed(4)}</td>
              <td>{deptEqRatioG4.toFixed(4)}</td>
              <td>{deptEqRatioH4.toFixed(4)}</td>
              <td>{deptEqRatioI4.toFixed(4)}</td>
            </tr>
          </tbody>
        </table>
        <div
          style={{
            width: "40%",
            marginLeft: "auto",
            alignSelf: "end",
          }}
        >
          <table style={{ width: "100%" }}>
            <thead>
              <th style={{ width: "50%" }}></th>
              <th style={{ width: "50%" }}></th>
            </thead>
            <tbody>
              <tr>
                <td>
                  <b>MAXIMUM D.E.R.</b>
                </td>
                <td>
                  <b>{maxDepEqC6.toFixed(4)}</b>
                </td>
              </tr>
              <tr>
                <td>
                  <b>MINIMUM D.E.R.</b>
                </td>
                <td>
                  <b>{minDepEqC7.toFixed(4)}</b>
                </td>
              </tr>
              <tr>
                <td>
                  <b>AVERAGE D.E.R.</b>
                </td>
                <td>
                  <b>{avgDepEqC8.toFixed(4)}</b>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      {/* table 13 */}
      <div style={{ pageBreakInside: "avoid" }}>
        <p
          className="fw-bold mt-4 mb-0 text-uppercase"
          style={{
            fontSize: "1rem",
          }}
        >
          SCHEDULE X : STATEMENT SHOWING FINANCIAL ANALYSIS
        </p>
        <p
          className="fw-bold mt-4 mb-0 text-uppercase"
          style={{
            fontSize: "1rem",
          }}
        >
          REVENUE, GROSS PROFIT, NET PROFIT
        </p>{" "}
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={{ width: "2%" }}>Sr.</th>
              <th style={{ width: "28%" }}>YEAR</th>
              <th style={{ width: "10%" }}>1st Year</th>
              <th style={{ width: "10%" }}>2nd Year</th>
              <th style={{ width: "10%" }}>3rd Year</th>
              <th style={{ width: "10%" }}>4th Year</th>
              <th style={{ width: "10%" }}>5th Year</th>
              <th style={{ width: "10%" }}>6th Year</th>
              <th style={{ width: "10%" }}>7th Year</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>A.</td>
              <td>GROSS REVENUE</td>
              <td>{roundOffCostWithNoFraction(grossRevenueC2)}</td>
              <td>{roundOffCostWithNoFraction(grossRevenueD2)}</td>
              <td>{roundOffCostWithNoFraction(grossRevenueE2)}</td>
              <td>{roundOffCostWithNoFraction(grossRevenueF2)}</td>
              <td>{roundOffCostWithNoFraction(grossRevenueG2)}</td>
              <td>{roundOffCostWithNoFraction(grossRevenueH2)}</td>
              <td>{roundOffCostWithNoFraction(grossRevenueI2)}</td>
            </tr>
            <tr>
              <td>B.</td>
              <td>GROSS PROFIT</td>
              <td>{roundOffCostWithNoFraction(grossProfitC3)}</td>
              <td>{roundOffCostWithNoFraction(grossProfitD3)}</td>
              <td>{roundOffCostWithNoFraction(grossProfitE3)}</td>
              <td>{roundOffCostWithNoFraction(grossProfitF3)}</td>
              <td>{roundOffCostWithNoFraction(grossProfitG3)}</td>
              <td>{roundOffCostWithNoFraction(grossProfitH3)}</td>
              <td>{roundOffCostWithNoFraction(grossProfitI3)}</td>
            </tr>
            <tr>
              <td>C.</td>
              <td>NET PROFIT AFTER TAX</td>
              <td>{roundOffCostWithNoFraction(netProfitAfterC4)}</td>
              <td>{roundOffCostWithNoFraction(netProfitAfterD4)}</td>
              <td>{roundOffCostWithNoFraction(netProfitAfterE4)}</td>
              <td>{roundOffCostWithNoFraction(netProfitAfterF4)}</td>
              <td>{roundOffCostWithNoFraction(netProfitAfterG4)}</td>
              <td>{roundOffCostWithNoFraction(netProfitAfterH4)}</td>
              <td>{roundOffCostWithNoFraction(netProfitAfterI4)}</td>
            </tr>
            <tr>
              <td>
                <b>D.</b>
              </td>
              <td>
                <b>NET PROFIT % TO SALES</b>
              </td>
              <td>
                <b>{netProfitToSalesC5.toFixed(2)}%</b>
              </td>
              <td>
                <b>{netProfitToSalesD5.toFixed(2)}%</b>
              </td>
              <td>
                <b>{netProfitToSalesE5.toFixed(2)}%</b>
              </td>
              <td>
                <b>{netProfitToSalesF5.toFixed(2)}%</b>
              </td>
              <td>
                <b>{netProfitToSalesG5.toFixed(2)}%</b>
              </td>
              <td>
                <b>{netProfitToSalesH5.toFixed(2)}%</b>
              </td>
              <td>
                <b>{netProfitToSalesI5.toFixed(2)}%</b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      {/* table 14 */}
      <div style={{ pageBreakInside: "avoid" }}>
        <p
          className="fw-bold mt-4 mb-0 text-uppercase"
          style={{
            fontSize: "1rem",
          }}
        >
          SCHEDULE XI : STATEMENT OF RATIO ANALYSIS
        </p>{" "}
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={{ width: "2%" }}>Sr.</th>
              <th style={{ width: "28%" }}>PARTICULARS</th>
              <th style={{ width: "10%" }}>1st Year</th>
              <th style={{ width: "10%" }}>2nd Year</th>
              <th style={{ width: "10%" }}>3rd Year</th>
              <th style={{ width: "10%" }}>4th Year</th>
              <th style={{ width: "10%" }}>5th Year</th>
              <th style={{ width: "10%" }}>6th Year</th>
              <th style={{ width: "10%" }}>7th Year</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <b>1.</b>
              </td>
              <td>
                <b>G.P. RATIO</b>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td>Total Sales</td>
              <td>{roundOffCostWithNoFraction(totalSalesC3)}</td>
              <td>{roundOffCostWithNoFraction(totalSalesD3)}</td>
              <td>{roundOffCostWithNoFraction(totalSalesE3)}</td>
              <td>{roundOffCostWithNoFraction(totalSalesF3)}</td>
              <td>{roundOffCostWithNoFraction(totalSalesG3)}</td>
              <td>{roundOffCostWithNoFraction(totalSalesH3)}</td>
              <td>{roundOffCostWithNoFraction(totalSalesI3)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Total Gross Profit</td>
              <td>{roundOffCostWithNoFraction(totalGrossProfitC4)}</td>
              <td>{roundOffCostWithNoFraction(totalGrossProfitD4)}</td>
              <td>{roundOffCostWithNoFraction(totalGrossProfitE4)}</td>
              <td>{roundOffCostWithNoFraction(totalGrossProfitF4)}</td>
              <td>{roundOffCostWithNoFraction(totalGrossProfitG4)}</td>
              <td>{roundOffCostWithNoFraction(totalGrossProfitH4)}</td>
              <td>{roundOffCostWithNoFraction(totalGrossProfitI4)}</td>
            </tr>
            <tr>
              <td>
                <b></b>
              </td>
              <td>
                <b>G.P. RATIO (%)</b>
              </td>
              <td>
                <b>{gPRatioC5.toFixed(2)}%</b>
              </td>
              <td>
                <b>{gPRatioD5.toFixed(2)}%</b>
              </td>
              <td>
                <b>{gPRatioE5.toFixed(2)}%</b>
              </td>
              <td>
                <b>{gPRatioF5.toFixed(2)}%</b>
              </td>
              <td>
                <b>{gPRatioG5.toFixed(2)}%</b>
              </td>
              <td>
                <b>{gPRatioH5.toFixed(2)}%</b>
              </td>
              <td>
                <b>{gPRatioI5.toFixed(2)}%</b>
              </td>
            </tr>
            <tr>
              <td>
                <b>2.</b>
              </td>
              <td>
                <b>N.P.RATIO</b>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td>Total Sales</td>
              <td>{roundOffCostWithNoFraction(totalSalesC7)}</td>
              <td>{roundOffCostWithNoFraction(totalSalesD7)}</td>
              <td>{roundOffCostWithNoFraction(totalSalesE7)}</td>
              <td>{roundOffCostWithNoFraction(totalSalesF7)}</td>
              <td>{roundOffCostWithNoFraction(totalSalesG7)}</td>
              <td>{roundOffCostWithNoFraction(totalSalesH7)}</td>
              <td>{roundOffCostWithNoFraction(totalSalesI7)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Net Profit After Tax</td>
              <td>{roundOffCostWithNoFraction(netProfitAfterTaxC8)}</td>
              <td>{roundOffCostWithNoFraction(netProfitAfterTaxD8)}</td>
              <td>{roundOffCostWithNoFraction(netProfitAfterTaxE8)}</td>
              <td>{roundOffCostWithNoFraction(netProfitAfterTaxF8)}</td>
              <td>{roundOffCostWithNoFraction(netProfitAfterTaxG8)}</td>
              <td>{roundOffCostWithNoFraction(netProfitAfterTaxH8)}</td>
              <td>{roundOffCostWithNoFraction(netProfitAfterTaxI8)}</td>
            </tr>
            <tr>
              <td>
                <b></b>
              </td>
              <td>
                <b>N.P.RATIO (%)</b>
              </td>
              <td>
                <b>{nPRatioC9.toFixed(2)}%</b>
              </td>
              <td>
                <b>{nPRatioD9.toFixed(2)}%</b>
              </td>
              <td>
                <b>{nPRatioE9.toFixed(2)}%</b>
              </td>
              <td>
                <b>{nPRatioF9.toFixed(2)}%</b>
              </td>
              <td>
                <b>{nPRatioG9.toFixed(2)}%</b>
              </td>
              <td>
                <b>{nPRatioH9.toFixed(2)}%</b>
              </td>
              <td>
                <b>{nPRatioI9.toFixed(2)}%</b>
              </td>
            </tr>
            <tr>
              <td>
                <b>3.</b>
              </td>
              <td>
                <b>DEBT SERVICE COVERAGE RATIO</b>
              </td>
              <td>
                <b>{deptServiceCovRatioC10.toFixed(2)}</b>
              </td>
              <td>
                <b>{deptServiceCovRatioD10.toFixed(2)}</b>
              </td>
              <td>
                <b>{deptServiceCovRatioE10.toFixed(2)}</b>
              </td>
              <td>
                <b>{deptServiceCovRatioF10.toFixed(2)}</b>
              </td>
              <td>
                <b>{deptServiceCovRatioG10.toFixed(2)}</b>
              </td>
              <td>
                <b>{deptServiceCovRatioH10.toFixed(2)}</b>
              </td>
              <td>
                <b>{deptServiceCovRatioI10.toFixed(2)}</b>
              </td>
            </tr>
            <tr>
              <td>
                <b>4.</b>
              </td>
              <td>
                <b>CURRENT RATIO</b>
              </td>
              <td>
                <b>{currRatioC11.toFixed(2)}</b>
              </td>
              <td>
                <b>{currRatioD11.toFixed(2)}</b>
              </td>
              <td>
                <b>{currRatioE11.toFixed(2)}</b>
              </td>
              <td>
                <b>{currRatioF11.toFixed(2)}</b>
              </td>
              <td>
                <b>{currRatioG11.toFixed(2)}</b>
              </td>
              <td>
                <b>{currRatioH11.toFixed(2)}</b>
              </td>
              <td>
                <b>{currRatioI11.toFixed(2)}</b>
              </td>
            </tr>
            <tr>
              <td>
                <b>5.</b>
              </td>
              <td>
                <b>QUICK/ LIQUID RATIO</b>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td>Quick Asset</td>
              <td>{roundOffCostWithNoFraction(quickAssetsC13)}</td>
              <td>{roundOffCostWithNoFraction(quickAssetsD13)}</td>
              <td>{roundOffCostWithNoFraction(quickAssetsE13)}</td>
              <td>{roundOffCostWithNoFraction(quickAssetsF13)}</td>
              <td>{roundOffCostWithNoFraction(quickAssetsG13)}</td>
              <td>{roundOffCostWithNoFraction(quickAssetsH13)}</td>
              <td>{roundOffCostWithNoFraction(quickAssetsI13)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Quick Liabilities</td>
              <td>{roundOffCostWithNoFraction(quickLiabilitiesC14)}</td>
              <td>{roundOffCostWithNoFraction(quickLiabilitiesD14)}</td>
              <td>{roundOffCostWithNoFraction(quickLiabilitiesE14)}</td>
              <td>{roundOffCostWithNoFraction(quickLiabilitiesF14)}</td>
              <td>{roundOffCostWithNoFraction(quickLiabilitiesG14)}</td>
              <td>{roundOffCostWithNoFraction(quickLiabilitiesH14)}</td>
              <td>{roundOffCostWithNoFraction(quickLiabilitiesI14)}</td>
            </tr>
            <tr>
              <td>
                <b></b>
              </td>
              <td>
                <b>Quick Ratio</b>
              </td>
              <td>
                <b>{quickRatioC15.toFixed(2)}</b>
              </td>
              <td>
                <b>{quickRatioD15.toFixed(2)}</b>
              </td>
              <td>
                <b>{quickRatioE15.toFixed(2)}</b>
              </td>
              <td>
                <b>{quickRatioF15.toFixed(2)}</b>
              </td>
              <td>
                <b>{quickRatioG15.toFixed(2)}</b>
              </td>
              <td>
                <b>{quickRatioH15.toFixed(2)}</b>
              </td>
              <td>
                <b>{quickRatioI15.toFixed(2)}</b>
              </td>
            </tr>
            <tr>
              <td>
                <b>6.</b>
              </td>
              <td>
                <b>Return on Capital Employed</b>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td>EBIT( Net Income+Interest)</td>
              <td>{roundOffCostWithNoFraction(ebitC17)}</td>
              <td>{roundOffCostWithNoFraction(ebitD17)}</td>
              <td>{roundOffCostWithNoFraction(ebitE17)}</td>
              <td>{roundOffCostWithNoFraction(ebitF17)}</td>
              <td>{roundOffCostWithNoFraction(ebitG17)}</td>
              <td>{roundOffCostWithNoFraction(ebitH17)}</td>
              <td>{roundOffCostWithNoFraction(ebitI17)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Capital Employeed( Total Asset - Current)</td>
              <td>{roundOffCostWithNoFraction(capitalEmployedC18)}</td>
              <td>{roundOffCostWithNoFraction(capitalEmployedD18)}</td>
              <td>{roundOffCostWithNoFraction(capitalEmployedE18)}</td>
              <td>{roundOffCostWithNoFraction(capitalEmployedF18)}</td>
              <td>{roundOffCostWithNoFraction(capitalEmployedG18)}</td>
              <td>{roundOffCostWithNoFraction(capitalEmployedH18)}</td>
              <td>{roundOffCostWithNoFraction(capitalEmployedI18)}</td>
            </tr>
            <tr>
              <td>
                <b></b>
              </td>
              <td>
                <b>R.O.C.(%)</b>
              </td>
              <td>
                <b>{rocC19.toFixed(2)}%</b>
              </td>
              <td>
                <b>{rocD19.toFixed(2)}%</b>
              </td>
              <td>
                <b>{rocE19.toFixed(2)}%</b>
              </td>
              <td>
                <b>{rocF19.toFixed(2)}%</b>
              </td>
              <td>
                <b>{rocG19.toFixed(2)}%</b>
              </td>
              <td>
                <b>{rocH19.toFixed(2)}%</b>
              </td>
              <td>
                <b>{rocI19.toFixed(2)}%</b>
              </td>
            </tr>
            <tr>
              <td>
                <b>7.</b>
              </td>
              <td>
                <b>Return on Net Worth</b>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td>Return</td>
              <td>{roundOffCostWithNoFraction(returnC21)}</td>
              <td>{roundOffCostWithNoFraction(returnD21)}</td>
              <td>{roundOffCostWithNoFraction(returnE21)}</td>
              <td>{roundOffCostWithNoFraction(returnF21)}</td>
              <td>{roundOffCostWithNoFraction(returnG21)}</td>
              <td>{roundOffCostWithNoFraction(returnH21)}</td>
              <td>{roundOffCostWithNoFraction(returnI21)}</td>
            </tr>
            <tr>
              <td></td>
              <td>Net Worth</td>
              <td>{roundOffCostWithNoFraction(netWorthC22)}</td>
              <td>{roundOffCostWithNoFraction(netWorthD22)}</td>
              <td>{roundOffCostWithNoFraction(netWorthE22)}</td>
              <td>{roundOffCostWithNoFraction(netWorthF22)}</td>
              <td>{roundOffCostWithNoFraction(netWorthG22)}</td>
              <td>{roundOffCostWithNoFraction(netWorthH22)}</td>
              <td>{roundOffCostWithNoFraction(netWorthI22)}</td>
            </tr>
            <tr>
              <td>
                <b></b>
              </td>
              <td>
                <b>Return on Net Worth(%)</b>
              </td>
              <td>
                <b>{returnOnNetWorthC23.toFixed(2)}%</b>
              </td>
              <td>
                <b>{returnOnNetWorthD23.toFixed(2)}%</b>
              </td>
              <td>
                <b>{returnOnNetWorthE23.toFixed(2)}%</b>
              </td>
              <td>
                <b>{returnOnNetWorthF23.toFixed(2)}%</b>
              </td>
              <td>
                <b>{returnOnNetWorthG23.toFixed(2)}%</b>
              </td>
              <td>
                <b>{returnOnNetWorthH23.toFixed(2)}%</b>
              </td>
              <td>
                <b>{returnOnNetWorthI23.toFixed(2)}%</b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>{" "}
      <div
        className="html2pdf__page-break"
        style={{
          pageBreakAfter: "always",
          display: "block",
          clear: "both",
        }}
      ></div>
    </div>
  );
};

export default BorrowFromBankSchedule2;
